// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/fira-code/FiraCode-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/fira-code/FiraCode-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/fira-code/FiraCode-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/fira-code/FiraCode-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/fira-code/FiraCode-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Fira Code";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}
@font-face {
  font-family: "Fira Code";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Fira Code";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}
@font-face {
  font-family: "Fira Code";
  font-weight: 600;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
@font-face {
  font-family: "Fira Code";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
}
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
a,
img,
ol,
ul,
li,
fieldset,
form,
label,
article,
aside,
details,
header,
nav,
section,
summary {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

body {
  min-height: 100vh;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
}

img,
picture {
  max-width: 100%;
  display: block;
}

input,
button,
textarea,
select {
  font: inherit;
}

button {
  appearance: none;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body, html {
  background-color: #050508 !important;
  color: #e0e0e0;
  font-family: "Fira Code", "Noto Sans JP", monospace;
  display: flex;
  gap: 112px;
  flex-direction: column;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow-x: hidden;
}

body::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at 20% 20%, rgba(180, 30, 30, 0.05) 0%, transparent 40%), radial-gradient(ellipse at 80% 80%, rgba(30, 30, 40, 0.1) 0%, transparent 40%), linear-gradient(180deg, #050508 0%, #0a0a12 50%, #050508 100%);
  pointer-events: none;
  z-index: -1000;
}

.dots {
  width: 10vmin;
  height: auto;
}
.dots circle {
  fill: #606060;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #050508;
}

::-webkit-scrollbar-thumb {
  background: rgba(180, 30, 30, 0.4);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(180, 30, 30, 0.6);
}

::selection {
  background: rgba(180, 30, 30, 0.4);
  color: #ffffff;
}

.media-header {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 16px;
  gap: 8px;
  top: 0px;
}
@media (max-width: 1024px) {
  .media-header {
    display: none;
  }
}
.media-header__links {
  display: grid;
  grid-auto-columns: 1fr;
}
.media-header__line {
  width: 1px;
  height: 33vh;
  background-color: rgba(180, 30, 30, 0.3);
  display: block;
}

.hamburger {
  width: 32px;
  margin: 0;
  aspect-ratio: 1;
  display: none;
  appearance: none;
  position: absolute;
  cursor: pointer;
  right: 8px;
  top: 32px;
  z-index: 9999;
}
.hamburger::before, .hamburger::after {
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  top: 30%;
  background-color: rgba(180, 30, 30, 0.7);
  transition: all 0.2s ease;
}
.hamburger::after {
  width: 75%;
  top: 70%;
  right: 0;
}
@media (max-width: 1024px) {
  .hamburger {
    display: block;
  }
  .hamburger:checked::after {
    transform: translateY(-50%) rotateZ(45deg);
    width: 100%;
    top: 50%;
  }
  .hamburger:checked::before {
    transform: translateY(-50%) rotateZ(-45deg);
    top: 50%;
  }
  .hamburger:checked ~ .media-header {
    display: flex;
    top: calc(100% - 16px);
    left: 50%;
    transform: translate(-50%, -100%);
    z-index: 9999;
  }
  .hamburger:checked ~ .media-header .media {
    width: 48px;
  }
  .hamburger:checked ~ .media-header .media-header__links {
    display: flex;
    gap: 16px;
  }
  .hamburger:checked ~ .media-header .media-header__line {
    display: none;
  }
  .hamburger:checked ~ .container {
    width: 100vw;
    height: 100vh;
  }
  .hamburger:checked ~ .container .dropdown {
    display: flex;
    position: absolute;
    bottom: -16px;
    font-size: 24px;
    transform: translateY(100%);
    right: 0;
  }
  .hamburger:checked ~ .container .header__inner {
    align-items: start;
  }
  .hamburger:checked ~ .container .header__links {
    display: flex;
    position: absolute;
    flex-direction: column;
    bottom: -32px;
    transform: translateY(100%);
    font-size: 24px;
  }
}

.header {
  padding-top: 32px;
  padding-bottom: 8px;
  background-color: rgba(5, 5, 8, 0.85);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
}
.header__inner {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
}
.header__links {
  margin-left: auto;
  display: flex;
  align-items: flex-start;
  gap: 32px;
}
.header__link {
  color: #909090;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  letter-spacing: 1px;
  position: relative;
  transition: all 0.3s ease;
}
.header__link_active {
  font-weight: 600;
  color: #e0e0e0;
  text-shadow: 0 0 10px rgba(180, 30, 30, 0.5);
}
.header__link::before {
  content: "‡";
  color: rgba(180, 30, 30, 0.8);
  font-weight: normal;
  margin-right: 4px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.header__link:hover {
  color: #e04545;
  text-shadow: 0 0 15px rgba(180, 30, 30, 0.5);
}
.header__link:hover::before {
  opacity: 1;
}
@media (max-width: 1024px) {
  .header {
    padding-top: 16px;
  }
  .header__links, .header .dropdown {
    display: none;
  }
}

.footer {
  max-width: inherit;
  width: 100%;
  border-top: 1px solid rgba(180, 30, 30, 0.3);
  padding-top: 32px;
  margin-bottom: 16px;
  background: linear-gradient(180deg, transparent 0%, rgba(5, 5, 8, 0.5) 100%);
}
.footer__copyright {
  color: #707070;
  text-align: center;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 12px;
  letter-spacing: 1px;
}
.footer__header {
  display: flex;
  gap: 32px;
  align-items: center;
}
.footer__contact-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.footer__contact-divider {
  color: rgba(180, 30, 30, 0.4);
  opacity: 0.5;
  -webkit-user-select: none;
          user-select: none;
}
.footer__contact-item {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.footer__contact-item:hover .footer__tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
.footer__email, .footer__phone {
  color: #909090;
  transition: all 0.25s ease;
  text-decoration: none;
  font-family: "Noto Sans JP", sans-serif;
}
.footer__email:hover, .footer__phone:hover {
  color: #e04545;
  text-shadow: 0 0 10px rgba(180, 30, 30, 0.5);
}
.footer__tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%) translateY(6px);
  white-space: nowrap;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 10;
}
.footer__tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
}
.footer__tooltip--email {
  background: rgba(180, 30, 30, 0.2);
  color: #e04545;
  border: 1px solid rgba(180, 30, 30, 0.4);
  backdrop-filter: blur(12px);
}
.footer__tooltip--email::after {
  border-top-color: rgba(180, 30, 30, 0.4);
}
.footer__tooltip--phone {
  background: rgba(180, 30, 30, 0.2);
  color: #e04545;
  border: 1px solid rgba(180, 30, 30, 0.4);
  backdrop-filter: blur(12px);
}
.footer__tooltip--phone::after {
  border-top-color: rgba(180, 30, 30, 0.4);
}
.footer__description {
  margin-top: 16px;
  color: #808080;
  font-family: "Noto Sans JP", sans-serif;
}
.footer__inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 32px;
  margin-bottom: 48px;
}
.footer__list {
  display: flex;
  gap: 8px;
}
.footer__title {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #e0e0e0;
  letter-spacing: 2px;
}

.footer-japanese {
  font-family: "Noto Sans JP", sans-serif;
  font-size: 10px;
  color: rgba(180, 30, 30, 0.6);
  letter-spacing: 4px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 16px;
  opacity: 0.7;
}

.button {
  display: inline-block;
  padding: 10px 20px;
  border: 1px solid rgba(180, 30, 30, 0.6);
  font-weight: 500;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  letter-spacing: 1px;
  background: rgba(180, 30, 30, 0.1);
  color: #e0e0e0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.3), transparent);
  transition: left 0.5s ease;
}
.button:hover {
  background-color: rgba(180, 30, 30, 0.25);
  border-color: rgba(180, 30, 30, 0.9);
  box-shadow: 0 0 20px rgba(180, 30, 30, 0.3);
}
.button:hover::before {
  left: 100%;
}
.button__secondary {
  border-color: rgba(120, 120, 130, 0.5);
  color: #909090;
  background: rgba(20, 20, 25, 0.5);
}
.button__secondary:hover {
  background-color: rgba(180, 30, 30, 0.15);
  border-color: rgba(180, 30, 30, 0.5);
  color: #e0e0e0;
}

.dropdown {
  color: var(--gray);
  position: relative;
}
.dropdown:hover .dropdown__list {
  display: flex;
}
.dropdown__label {
  cursor: pointer;
  text-transform: uppercase;
}
.dropdown__label::after {
  content: "V";
  display: inline-block;
  scale: 1 0.3;
  font-weight: 500;
  margin-left: 4px;
}
.dropdown__label:hover {
  color: var(--white);
}
.dropdown__label:hover::after {
  rotate: 180deg;
}
.dropdown__list {
  display: none;
  flex-direction: column;
  border: 1px solid var(--gray);
  position: absolute;
  background-color: var(--background);
  bottom: 0;
  transform: translateY(100%);
}
.dropdown__option {
  cursor: pointer;
  padding: 8px;
  text-transform: uppercase;
}
.dropdown__option:hover {
  color: var(--white);
}
.dropdown__option:first-child {
  padding-bottom: 4px;
}
.dropdown__option:nth-child(2) {
  padding-top: 4px;
}

.media {
  width: 32px;
  aspect-ratio: 1;
}
.media__icon {
  width: 100%;
  aspect-ratio: 1;
}
.media__icon:hover {
  filter: brightness(0) invert(1);
}

.path {
  align-self: start;
  display: block;
  width: 100%;
}
.path__name {
  font-size: 32px;
  font-weight: 600;
}
.path__name::before {
  content: "/";
  color: var(--primary);
}
.path__description {
  color: var(--gray);
  margin-top: 16px;
}

.h2 {
  font-size: 32px;
  font-weight: 500;
  position: relative;
  float: none;
  clear: both;
  display: inline-block;
}
.h2::before {
  content: "#";
  color: var(--primary);
}
.h2::after {
  content: "";
  display: block;
  width: 10vw;
  height: 1px;
  background-color: var(--primary);
  position: absolute;
  transform: translate(100%, -50%);
  right: -16px;
  top: 50%;
}

.container {
  max-width: 1024px;
  margin: 0 auto;
  position: relative;
}
@media (max-width: 1024px) {
  .container {
    padding: 16px;
  }
}

.content {
  margin-top: 112px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 112px;
}

.logo {
  display: flex;
  gap: 8px;
}
.logo__img {
  aspect-ratio: 1;
  width: 16px;
}
.logo__name {
  font-weight: 700;
}

.project {
  border: 1px solid rgba(180, 30, 30, 0.3);
  background: rgba(8, 8, 12, 0.6);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.project::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.project:hover {
  border-color: rgba(180, 30, 30, 0.6);
  box-shadow: 0 0 30px rgba(180, 30, 30, 0.2), inset 0 0 20px rgba(180, 30, 30, 0.05);
}
.project:hover::before {
  opacity: 1;
}
.project__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.project__image {
  border-bottom: 1px solid rgba(180, 30, 30, 0.3);
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
}
.project__image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 50%, rgba(8, 8, 12, 0.8) 100%);
}
.project__content {
  padding: 16px;
  position: relative;
  z-index: 1;
}
.project__name {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #e0e0e0;
}
.project__description {
  color: #909090;
  margin: 16px 0;
  line-height: 1.6;
}
.project__techs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  color: #707070;
  padding: 8px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-size: 12px;
  font-family: "Noto Sans JP", sans-serif;
  letter-spacing: 0.5px;
}

.project-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;
  margin-top: 48px;
}
@media (max-width: 1024px) {
  .project-list {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.skill-block {
  border: 1px solid rgba(180, 30, 30, 0.25);
  display: inline-block;
  max-width: 300px;
  min-width: 200px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  background: rgba(8, 8, 12, 0.5);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.skill-block::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, rgba(180, 30, 30, 0.6), rgba(180, 30, 30, 0.1));
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.skill-block:hover {
  border-color: rgba(180, 30, 30, 0.5);
  box-shadow: 0 0 20px rgba(180, 30, 30, 0.15);
}
.skill-block:hover::before {
  opacity: 1;
}
.skill-block__name {
  font-weight: 600;
  padding: 12px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  color: #e0e0e0;
  letter-spacing: 1px;
}
.skill-block__list {
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: start;
  align-items: start;
  color: #909090;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
}

@font-face {
  font-family: "samurai-code";
  src: url("http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.eot?#iefix") format("embedded-opentype"), url("http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.woff") format("woff"), url("http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.ttf") format("truetype"), url("http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.ttf#svgFontName") format("svg");
}
#matrix-rain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  pointer-events: none;
  background: #050508;
  display: block;
  margin: 0;
  padding: 0;
}

body, html {
  background: #050508 !important;
  margin: 0;
  padding: 0;
}

.content {
  position: relative;
  z-index: 1;
}
.content h1, .content h2, .content h3, .content h4, .content h5, .content h6 {
  text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 30px rgba(180, 30, 30, 0.3);
  color: #e8e8e8;
}
.content p {
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(180, 30, 30, 0.2);
  color: #a0a0a0;
}

.header, .footer {
  position: relative;
  z-index: 2;
  background: rgba(5, 5, 8, 0.6);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
}

.footer {
  border-top: 1px solid rgba(180, 30, 30, 0.2);
  border-bottom: none;
}

.button, .header__link, .contact {
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
  transition: all 0.3s ease;
}
.button:hover, .header__link:hover, .contact:hover {
  text-shadow: 0 0 20px rgba(180, 30, 30, 0.6), 0 0 10px rgba(0, 0, 0, 0.9);
  color: rgba(220, 60, 60, 0.9);
}

.project, .contact {
  border: 1px solid transparent;
  transition: all 0.3s ease;
  background: rgba(5, 5, 8, 0.4);
  backdrop-filter: blur(4px);
}
.project:hover, .contact:hover {
  border-color: rgba(180, 30, 30, 0.5);
  box-shadow: 0 0 25px rgba(180, 30, 30, 0.25), inset 0 0 30px rgba(180, 30, 30, 0.05);
  background: rgba(10, 10, 15, 0.6);
}

.skill, .skillBlock {
  background: rgba(8, 8, 12, 0.5);
  border: 1px solid rgba(180, 30, 30, 0.2);
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
}
.skill:hover, .skillBlock:hover {
  border-color: rgba(180, 30, 30, 0.6);
  box-shadow: 0 0 20px rgba(180, 30, 30, 0.3), inset 0 0 15px rgba(180, 30, 30, 0.1);
}

.katana-accent {
  position: relative;
}
.katana-accent::before {
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, rgba(180, 30, 30, 0.8), rgba(180, 30, 30, 0.1));
  left: 0;
  top: 0;
}

.sakura-decoration {
  position: relative;
}
.sakura-decoration::after {
  content: "❀";
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(180, 40, 60, 0.6);
  font-size: 12px;
}

.japanese-text {
  font-family: "Noto Sans JP", "Zen Kaku Gothic New", sans-serif;
  letter-spacing: 2px;
}
.japanese-text--small {
  font-size: 0.75em;
  opacity: 0.7;
}

.dramatic-light {
  position: relative;
}
.dramatic-light::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at center, transparent 0%, rgba(5, 5, 8, 0.4) 70%, rgba(5, 5, 8, 0.9) 100%);
  pointer-events: none;
}

.about {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.about::before {
  content: "";
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.2), transparent);
}
.about__content {
  flex: 1 1;
  min-width: 300px;
}
.about__text {
  margin-bottom: 32px;
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.about__description {
  color: #909090;
  line-height: 1.8;
  font-family: "Noto Sans JP", sans-serif;
}
.about__image {
  flex: 1 1;
  max-width: 340px;
  border-bottom: 2px solid rgba(180, 30, 30, 0.5);
  position: relative;
  overflow: hidden;
}
.about__image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 60%, rgba(5, 5, 8, 0.8) 100%);
}
.about__image::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.8), transparent);
}

.contacts {
  width: 100%;
}
.contacts__content {
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 48px;
}
.contacts__title {
  font-weight: 600;
}
.contacts__list {
  margin-top: 16px;
}
.contacts__media {
  border: 1px solid var(--gray);
  padding: 16px;
}
.contacts__description {
  color: var(--gray);
  max-width: 600px;
}

.contact {
  display: flex;
  gap: 8px;
  color: var(--gray);
  align-items: center;
  margin-top: 8px;
}
.contact:hover {
  filter: brightness(0) invert(1);
}

.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  position: relative;
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at 30% 50%, rgba(180, 30, 30, 0.08) 0%, transparent 50%, rgba(5, 5, 8, 0.4) 100%);
  pointer-events: none;
  z-index: 0;
}
.hero .dots {
  position: absolute;
  top: 40%;
  width: 12vmin;
  left: 70%;
  z-index: 4;
}
.hero__logo {
  position: absolute;
  width: 30vmin;
  top: 10%;
  z-index: 1;
  aspect-ratio: 1;
}
.hero__image {
  position: relative;
  z-index: 2;
  border-bottom: 2px solid rgba(180, 30, 30, 0.6);
  box-shadow: 0 4px 20px rgba(180, 30, 30, 0.3);
}
.hero__content, .hero__illustrations {
  flex: 1 1;
  position: relative;
  z-index: 2;
}
.hero__illustrations {
  position: relative;
  display: flex;
  flex-direction: column;
}
.hero__title {
  min-width: 300px;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 32px;
  font-weight: 700;
}
.hero__title span {
  color: #b41e1e;
  transition: color 0.35s ease;
  text-shadow: 0 0 20px rgba(180, 30, 30, 0.5);
}
.hero__title--hovered {
  animation: heroTextSwap 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.hero__title--hovered span {
  color: #e04545;
}
.hero__description {
  color: #909090;
  margin-top: 32px;
  margin-bottom: 32px;
  line-height: 1.8;
  font-family: "Noto Sans JP", sans-serif;
}
.hero__status {
  padding: 8px 16px;
  border: 1px solid rgba(180, 30, 30, 0.4);
  color: #b0b0b0;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -1px;
  z-index: 5;
  gap: 8px;
  font-weight: 500;
  background: rgba(5, 5, 8, 0.6);
  backdrop-filter: blur(4px);
}
.hero__status::before {
  content: "";
  display: inline-block;
  aspect-ratio: 1;
  width: 16px;
  background-color: rgba(180, 30, 30, 0.2);
  border: 1px solid rgba(180, 30, 30, 0.5);
}
.hero__status a {
  color: #e0e0e0;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.hero__status a:hover {
  color: #e04545;
  text-shadow: 0 0 10px rgba(224, 69, 69, 0.5);
}
.hero__japanese {
  font-family: "Noto Sans JP", sans-serif;
  font-size: 14px;
  color: rgba(180, 30, 30, 0.7);
  letter-spacing: 3px;
  margin-top: 8px;
  text-transform: uppercase;
}

.katana-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent);
  margin: 24px 0;
  position: relative;
}
.katana-divider::before, .katana-divider::after {
  content: "◆";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(180, 30, 30, 0.8);
  font-size: 8px;
}
.katana-divider::before {
  left: 20%;
}
.katana-divider::after {
  right: 20%;
}

@keyframes heroTextSwap {
  0% {
    opacity: 0.3;
    filter: blur(4px);
    transform: scale(0.97);
  }
  50% {
    opacity: 0.8;
    filter: blur(1px);
    transform: scale(1.01);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    transform: scale(1);
  }
}
@keyframes sakuraFall {
  0% {
    transform: translateY(-10px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
    opacity: 0;
  }
}
.sakura-petal-hero {
  position: absolute;
  width: 8px;
  height: 8px;
  background: radial-gradient(circle, rgba(180, 40, 60, 0.8) 0%, rgba(200, 80, 100, 0.4) 100%);
  border-radius: 50% 50% 50% 50%/60% 60% 40% 40%;
  animation: sakuraFall 8s linear infinite;
  pointer-events: none;
  z-index: 1;
}
.sakura-petal-hero:nth-child(1) {
  left: 10%;
  animation-delay: 0s;
  animation-duration: 8s;
}
.sakura-petal-hero:nth-child(2) {
  left: 30%;
  animation-delay: -3s;
  animation-duration: 10s;
}
.sakura-petal-hero:nth-child(3) {
  left: 70%;
  animation-delay: -5s;
  animation-duration: 7s;
}
.sakura-petal-hero:nth-child(4) {
  left: 85%;
  animation-delay: -2s;
  animation-duration: 9s;
}

.projects__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 48px;
}
.projects__link {
  text-decoration: underline;
}
.projects__link:hover {
  color: var(--primary);
}

.quote {
  border: 1px solid var(--gray);
  position: relative;
  margin: 0;
}
.quote::before, .quote::after {
  content: '"';
  position: absolute;
  color: var(--gray);
  font-size: 64px;
  font-weight: 700;
  background-image: linear-gradient(var(--background), var(--background));
  background-size: 100% 40%;
  background-repeat: no-repeat;
}
.quote::before {
  top: -32px;
  left: 16px;
}
.quote::after {
  bottom: -64px;
  right: 16px;
}
.quote__text {
  padding: 32px;
  font-size: 24px;
  font-weight: 500;
  background-color: var(--background);
}
.quote__author {
  position: absolute;
  color: var(--gray);
  border: 1px solid var(--gray);
  padding: 8px;
  right: -1px;
  font-size: 16px;
}
.quote__author::before {
  content: "- ";
}

.skills {
  width: 100%;
  position: relative;
}
.skills::before {
  content: "";
  position: absolute;
  top: -50px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.3), transparent);
}
.skills__content {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}
.skills .skill-block {
  margin-bottom: 16px;
}
.skills__list {
  column-gap: 16px;
  columns: 3;
}
@media (max-width: 768px) {
  .skills__list {
    columns: 2;
  }
}
@media (max-width: 500px) {
  .skills__list {
    columns: 1;
  }
}
.skills__illustrations, .skills__list {
  flex: 1 1;
}

.skills-title {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  position: relative;
  display: inline-block;
}
.skills-title::after {
  content: "技";
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(180, 30, 30, 0.5);
  letter-spacing: 2px;
}

.illustrations {
  position: relative;
  min-width: 300px;
  min-height: 300px;
}
.illustrations__logo {
  width: 14vmin;
  top: 30%;
  position: absolute;
  left: 70%;
}
.illustrations .dots:nth-of-type(2) {
  width: 16vmin;
  top: 70%;
  left: 10%;
  position: absolute;
}
.illustrations .dots:nth-of-type(1) {
  width: 10vmin;
  top: 20%;
  left: 40%;
  position: absolute;
}

.project {
  border: 1px solid rgba(180, 30, 30, 0.3);
  background: rgba(8, 8, 12, 0.6);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.project::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.project:hover {
  border-color: rgba(180, 30, 30, 0.6);
  box-shadow: 0 0 30px rgba(180, 30, 30, 0.2), inset 0 0 20px rgba(180, 30, 30, 0.05);
}
.project:hover::before {
  opacity: 1;
}
.project__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.project__image {
  border-bottom: 1px solid rgba(180, 30, 30, 0.3);
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
}
.project__image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 50%, rgba(8, 8, 12, 0.8) 100%);
}
.project__content {
  padding: 16px;
  position: relative;
  z-index: 1;
}
.project__name {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #e0e0e0;
}
.project__description {
  color: #909090;
  margin: 16px 0;
  line-height: 1.6;
}
.project__techs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  color: #707070;
  padding: 8px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-size: 12px;
  font-family: "Noto Sans JP", sans-serif;
  letter-spacing: 0.5px;
}

.project-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;
  margin-top: 48px;
}
@media (max-width: 1024px) {
  .project-list {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.skill-block {
  border: 1px solid rgba(180, 30, 30, 0.25);
  display: inline-block;
  max-width: 300px;
  min-width: 200px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  background: rgba(8, 8, 12, 0.5);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.skill-block::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, rgba(180, 30, 30, 0.6), rgba(180, 30, 30, 0.1));
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.skill-block:hover {
  border-color: rgba(180, 30, 30, 0.5);
  box-shadow: 0 0 20px rgba(180, 30, 30, 0.15);
}
.skill-block:hover::before {
  opacity: 1;
}
.skill-block__name {
  font-weight: 600;
  padding: 12px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  color: #e0e0e0;
  letter-spacing: 1px;
}
.skill-block__list {
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: start;
  align-items: start;
  color: #909090;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
}

.skill-block {
  border: 1px solid rgba(180, 30, 30, 0.25);
  display: inline-block;
  max-width: 300px;
  min-width: 200px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  background: rgba(8, 8, 12, 0.5);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.skill-block::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, rgba(180, 30, 30, 0.6), rgba(180, 30, 30, 0.1));
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.skill-block:hover {
  border-color: rgba(180, 30, 30, 0.5);
  box-shadow: 0 0 20px rgba(180, 30, 30, 0.15);
}
.skill-block:hover::before {
  opacity: 1;
}
.skill-block__name {
  font-weight: 600;
  padding: 12px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  color: #e0e0e0;
  letter-spacing: 1px;
}
.skill-block__list {
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: start;
  align-items: start;
  color: #909090;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
}

.about {
  display: flex;
  justify-content: space-between;
  gap: 48px;
  align-items: center;
  flex-wrap: wrap;
}
.about__text {
  flex: 3 1;
  color: var(--gray);
  min-width: 300px;
}
.about__description {
  margin-bottom: 16px;
}
.about__illustrations {
  flex: 1 1;
  min-width: 300px;
}
.about__image {
  border-bottom: 1px solid var(--primary);
}

.skills__content {
  margin-top: 48px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: start;
}

.fact {
  padding: 8px;
  color: var(--gray);
  border: 1px solid var(--gray);
}

.facts__content {
  display: flex;
  align-items: start;
  flex-wrap: wrap;
}
.facts__list {
  margin-top: 48px;
  display: flex;
  gap: 16px;
  align-items: start;
  flex-wrap: wrap;
}

.project {
  border: 1px solid rgba(180, 30, 30, 0.3);
  background: rgba(8, 8, 12, 0.6);
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.project::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.project:hover {
  border-color: rgba(180, 30, 30, 0.6);
  box-shadow: 0 0 30px rgba(180, 30, 30, 0.2), inset 0 0 20px rgba(180, 30, 30, 0.05);
}
.project:hover::before {
  opacity: 1;
}
.project__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.project__image {
  border-bottom: 1px solid rgba(180, 30, 30, 0.3);
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
}
.project__image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 50%, rgba(8, 8, 12, 0.8) 100%);
}
.project__content {
  padding: 16px;
  position: relative;
  z-index: 1;
}
.project__name {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #e0e0e0;
}
.project__description {
  color: #909090;
  margin: 16px 0;
  line-height: 1.6;
}
.project__techs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  color: #707070;
  padding: 8px;
  border-bottom: 1px solid rgba(180, 30, 30, 0.2);
  font-size: 12px;
  font-family: "Noto Sans JP", sans-serif;
  letter-spacing: 0.5px;
}

.project-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;
  margin-top: 48px;
}
@media (max-width: 1024px) {
  .project-list {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  position: relative;
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at 30% 50%, rgba(180, 30, 30, 0.08) 0%, transparent 50%, rgba(5, 5, 8, 0.4) 100%);
  pointer-events: none;
  z-index: 0;
}
.hero .dots {
  position: absolute;
  top: 40%;
  width: 12vmin;
  left: 70%;
  z-index: 4;
}
.hero__logo {
  position: absolute;
  width: 30vmin;
  top: 10%;
  z-index: 1;
  aspect-ratio: 1;
}
.hero__image {
  position: relative;
  z-index: 2;
  border-bottom: 2px solid rgba(180, 30, 30, 0.6);
  box-shadow: 0 4px 20px rgba(180, 30, 30, 0.3);
}
.hero__content, .hero__illustrations {
  flex: 1 1;
  position: relative;
  z-index: 2;
}
.hero__illustrations {
  position: relative;
  display: flex;
  flex-direction: column;
}
.hero__title {
  min-width: 300px;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 32px;
  font-weight: 700;
}
.hero__title span {
  color: #b41e1e;
  transition: color 0.35s ease;
  text-shadow: 0 0 20px rgba(180, 30, 30, 0.5);
}
.hero__title--hovered {
  animation: heroTextSwap 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.hero__title--hovered span {
  color: #e04545;
}
.hero__description {
  color: #909090;
  margin-top: 32px;
  margin-bottom: 32px;
  line-height: 1.8;
  font-family: "Noto Sans JP", sans-serif;
}
.hero__status {
  padding: 8px 16px;
  border: 1px solid rgba(180, 30, 30, 0.4);
  color: #b0b0b0;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -1px;
  z-index: 5;
  gap: 8px;
  font-weight: 500;
  background: rgba(5, 5, 8, 0.6);
  backdrop-filter: blur(4px);
}
.hero__status::before {
  content: "";
  display: inline-block;
  aspect-ratio: 1;
  width: 16px;
  background-color: rgba(180, 30, 30, 0.2);
  border: 1px solid rgba(180, 30, 30, 0.5);
}
.hero__status a {
  color: #e0e0e0;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.hero__status a:hover {
  color: #e04545;
  text-shadow: 0 0 10px rgba(224, 69, 69, 0.5);
}
.hero__japanese {
  font-family: "Noto Sans JP", sans-serif;
  font-size: 14px;
  color: rgba(180, 30, 30, 0.7);
  letter-spacing: 3px;
  margin-top: 8px;
  text-transform: uppercase;
}

.katana-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent);
  margin: 24px 0;
  position: relative;
}
.katana-divider::before, .katana-divider::after {
  content: "◆";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(180, 30, 30, 0.8);
  font-size: 8px;
}
.katana-divider::before {
  left: 20%;
}
.katana-divider::after {
  right: 20%;
}

@keyframes heroTextSwap {
  0% {
    opacity: 0.3;
    filter: blur(4px);
    transform: scale(0.97);
  }
  50% {
    opacity: 0.8;
    filter: blur(1px);
    transform: scale(1.01);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    transform: scale(1);
  }
}
@keyframes sakuraFall {
  0% {
    transform: translateY(-10px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
    opacity: 0;
  }
}
.sakura-petal-hero {
  position: absolute;
  width: 8px;
  height: 8px;
  background: radial-gradient(circle, rgba(180, 40, 60, 0.8) 0%, rgba(200, 80, 100, 0.4) 100%);
  border-radius: 50% 50% 50% 50%/60% 60% 40% 40%;
  animation: sakuraFall 8s linear infinite;
  pointer-events: none;
  z-index: 1;
}
.sakura-petal-hero:nth-child(1) {
  left: 10%;
  animation-delay: 0s;
  animation-duration: 8s;
}
.sakura-petal-hero:nth-child(2) {
  left: 30%;
  animation-delay: -3s;
  animation-duration: 10s;
}
.sakura-petal-hero:nth-child(3) {
  left: 70%;
  animation-delay: -5s;
  animation-duration: 7s;
}
.sakura-petal-hero:nth-child(4) {
  left: 85%;
  animation-delay: -2s;
  animation-duration: 9s;
}

.about {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.about::before {
  content: "";
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.2), transparent);
}
.about__content {
  flex: 1 1;
  min-width: 300px;
}
.about__text {
  margin-bottom: 32px;
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.about__description {
  color: #909090;
  line-height: 1.8;
  font-family: "Noto Sans JP", sans-serif;
}
.about__image {
  flex: 1 1;
  max-width: 340px;
  border-bottom: 2px solid rgba(180, 30, 30, 0.5);
  position: relative;
  overflow: hidden;
}
.about__image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 60%, rgba(5, 5, 8, 0.8) 100%);
}
.about__image::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.8), transparent);
}

.contacts {
  width: 100%;
}
.contacts__content {
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 48px;
}
.contacts__title {
  font-weight: 600;
}
.contacts__list {
  margin-top: 16px;
}
.contacts__media {
  border: 1px solid var(--gray);
  padding: 16px;
}
.contacts__description {
  color: var(--gray);
  max-width: 600px;
}

.contact {
  display: flex;
  gap: 8px;
  color: var(--gray);
  align-items: center;
  margin-top: 8px;
}
.contact:hover {
  filter: brightness(0) invert(1);
}

.projects__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 48px;
}
.projects__link {
  text-decoration: underline;
}
.projects__link:hover {
  color: var(--primary);
}

.quote {
  border: 1px solid var(--gray);
  position: relative;
  margin: 0;
}
.quote::before, .quote::after {
  content: '"';
  position: absolute;
  color: var(--gray);
  font-size: 64px;
  font-weight: 700;
  background-image: linear-gradient(var(--background), var(--background));
  background-size: 100% 40%;
  background-repeat: no-repeat;
}
.quote::before {
  top: -32px;
  left: 16px;
}
.quote::after {
  bottom: -64px;
  right: 16px;
}
.quote__text {
  padding: 32px;
  font-size: 24px;
  font-weight: 500;
  background-color: var(--background);
}
.quote__author {
  position: absolute;
  color: var(--gray);
  border: 1px solid var(--gray);
  padding: 8px;
  right: -1px;
  font-size: 16px;
}
.quote__author::before {
  content: "- ";
}

.skills {
  width: 100%;
  position: relative;
}
.skills::before {
  content: "";
  position: absolute;
  top: -50px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.3), transparent);
}
.skills__content {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}
.skills .skill-block {
  margin-bottom: 16px;
}
.skills__list {
  column-gap: 16px;
  columns: 3;
}
@media (max-width: 768px) {
  .skills__list {
    columns: 2;
  }
}
@media (max-width: 500px) {
  .skills__list {
    columns: 1;
  }
}
.skills__illustrations, .skills__list {
  flex: 1 1;
}

.skills-title {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  position: relative;
  display: inline-block;
}
.skills-title::after {
  content: "技";
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(180, 30, 30, 0.5);
  letter-spacing: 2px;
}

.illustrations {
  position: relative;
  min-width: 300px;
  min-height: 300px;
}
.illustrations__logo {
  width: 14vmin;
  top: 30%;
  position: absolute;
  left: 70%;
}
.illustrations .dots:nth-of-type(2) {
  width: 16vmin;
  top: 70%;
  left: 10%;
  position: absolute;
}
.illustrations .dots:nth-of-type(1) {
  width: 10vmin;
  top: 20%;
  left: 40%;
  position: absolute;
}

.about {
  display: flex;
  justify-content: space-between;
  gap: 48px;
  align-items: center;
  flex-wrap: wrap;
}
.about__text {
  flex: 3 1;
  color: var(--gray);
  min-width: 300px;
}
.about__description {
  margin-bottom: 16px;
}
.about__illustrations {
  flex: 1 1;
  min-width: 300px;
}
.about__image {
  border-bottom: 1px solid var(--primary);
}

.fact {
  padding: 8px;
  color: var(--gray);
  border: 1px solid var(--gray);
}

.facts__content {
  display: flex;
  align-items: start;
  flex-wrap: wrap;
}
.facts__list {
  margin-top: 48px;
  display: flex;
  gap: 16px;
  align-items: start;
  flex-wrap: wrap;
}

.skills__content {
  margin-top: 48px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: start;
}

:root {
  --primary: hsl(0 80% 45%);
  --primary-op: hsl(0 80% 45%/0.1);
  --secondary: hsl(350 70% 50%);
  --secondary-op: hsl(350 70% 50%/0.1);
  --gray: hsl(0 0% 60%);
  --gray-op: hsl(0 0% 60%/0.1);
  --background: hsl(240 20% 3%);
  --white: hsl(0 0% 90%);
  --accent-red: hsl(0 85% 50%);
  --accent-gold: hsl(40 80% 50%);
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.sass","webpack://./src/assets/styles/default/font.sass","webpack://./src/assets/styles/default/reset.sass","webpack://./src/assets/styles/default/default.sass","webpack://./src/assets/styles/components/header.sass","webpack://./src/assets/styles/components/footer.sass","webpack://./src/assets/styles/components/button.sass","webpack://./src/assets/styles/components/dropdown.sass","webpack://./src/assets/styles/components/mediaIcon.sass","webpack://./src/assets/styles/components/path.sass","webpack://./src/assets/styles/components/h2.sass","webpack://./src/assets/styles/components/container.sass","webpack://./src/assets/styles/default/variables.scss","webpack://./src/assets/styles/components/logo.sass","webpack://./src/assets/styles/components/project.sass","webpack://./src/assets/styles/components/skillBlock.sass","webpack://./src/assets/styles/components/matrix.sass","webpack://./src/assets/styles/blocks/home/about.sass","webpack://./src/assets/styles/blocks/home/contacts.sass","webpack://./src/assets/styles/blocks/home/hero.sass","webpack://./src/assets/styles/blocks/home/projects.sass","webpack://./src/assets/styles/blocks/home/quote.sass","webpack://./src/assets/styles/blocks/home/skills.sass","webpack://./src/assets/styles/blocks/about/about.sass","webpack://./src/assets/styles/blocks/about/skills.sass","webpack://./src/assets/styles/blocks/about/facts.sass"],"names":[],"mappings":"AAAA,gBAAgB;ACKZ;EAEQ,wBAAA;EACA,gBAPJ;EAQI,kBAAA;EACJ,2DAAA;ADCR;ACNI;EAEQ,wBAAA;EACA,gBAPJ;EAQI,kBAAA;EACJ,2DAAA;ADOR;ACZI;EAEQ,wBAAA;EACA,gBAPJ;EAQI,kBAAA;EACJ,2DAAA;ADaR;AClBI;EAEQ,wBAAA;EACA,gBAPJ;EAQI,kBAAA;EACJ,2DAAA;ADmBR;ACxBI;EAEQ,wBAAA;EACA,gBAPJ;EAQI,kBAAA;EACJ,2DAAA;ADyBR;AEnCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BI,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AFqCJ;;AEnCA;EACI,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AFsCJ;;AEpCA;EACI,qBAAA;EACA,cAAA;AFuCJ;;AErCA;EACI,gBAAA;AFwCJ;;AEtCA;;EAEI,eAAA;EACA,cAAA;AFyCJ;;AEvCA;;;;EAII,aAAA;AF0CJ;;AEvCA;EACI,gBAAA;AF0CJ;;AExCA;;;EAGI,sBAAA;AF2CJ;;AG3GA;EACI,oCAAA;EACA,cAAA;EACA,mDAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AH8GJ;;AG1GI;EACI,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4OAAA;EACA,oBAAA;EACA,cAAA;AH6GR;;AG3GA;EACI,aAAA;EACA,YAAA;AH8GJ;AG5GI;EACI,aAAA;AH8GR;;AG3GA;EACI,UAAA;AH8GJ;;AG5GA;EACI,mBAAA;AH+GJ;;AG7GA;EACI,kCAAA;EACA,kBAAA;AHgHJ;AG9GI;EACI,kCAAA;AHgHR;;AG7GA;EACI,kCAAA;EACA,cAAA;AHgHJ;;AI/JA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;AJkKJ;AIhKI;EAVJ;IAWQ,aAAA;EJmKN;AACF;AIjKI;EACI,aAAA;EACA,sBAAA;AJmKR;AIjKI;EACI,UAAA;EACA,YAAA;EACA,wCAAA;EACA,cAAA;AJmKR;;AIjKA;EACI,WAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AJoKJ;AIlKI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,wCAAA;EACA,yBAAA;AJoKR;AIlKI;EACI,UAAA;EACA,QAAA;EACA,QAAA;AJoKR;AIlKI;EA1BJ;IA2BQ,cAAA;EJqKN;EIlKU;IACI,0CAAA;IACA,WAAA;IACA,QAAA;EJoKd;EIlKU;IACI,2CAAA;IACA,QAAA;EJoKd;EIjKU;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,iCAAA;IACA,aAAA;EJmKd;EIjKc;IACI,WAAA;EJmKlB;EIjKc;IACI,aAAA;IACA,SAAA;EJmKlB;EIjKc;IACI,aAAA;EJmKlB;EIhKU;IACI,YAAA;IACA,aAAA;EJkKd;EIhKc;IACI,aAAA;IACA,kBAAA;IACA,aAAA;IACA,eAAA;IACA,2BAAA;IACA,QAAA;EJkKlB;EI/JkB;IACI,kBAAA;EJiKtB;EI/JkB;IACI,aAAA;IACA,kBAAA;IACA,sBAAA;IACA,aAAA;IACA,2BAAA;IACA,eAAA;EJiKtB;AACF;;AI/JA;EAEQ,iBAAA;EACA,mBAAA;EACJ,qCAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AJiKJ;AI/JI;EACI,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AJiKR;AI9JI;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AJgKR;AI7JI;EACI,cAAA;EACA,8DAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AJ+JR;AI7JQ;EACI,gBAAA;EACA,cAAA;EACA,4CAAA;AJ+JZ;AI7JQ;EACI,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,6BAAA;AJ+JZ;AI7JQ;EACI,cAAA;EACA,4CAAA;AJ+JZ;AI7JY;EACI,UAAA;AJ+JhB;AI7JI;EAvDJ;IAwDQ,iBAAA;EJgKN;EI9JM;IACI,aAAA;EJgKV;AACF;;AKzUA;EACI,kBAAA;EACA,WAAA;EACA,4CAAA;EACA,iBAAA;EACA,mBAAA;EACA,4EAAA;AL4UJ;AK1UI;EACI,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AL4UR;AK1UI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AL4UR;AK1UI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AL4UR;AK1UI;EACI,6BAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AL4UR;AK1UI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;AL4UR;AK1UQ;EACI,UAAA;EACA,mBAAA;EACA,yCAAA;AL4UZ;AK1UI;EACI,cAAA;EACA,0BAAA;EACA,qBAAA;EACA,uCAAA;AL4UR;AK1UQ;EACI,cAAA;EACA,4CAAA;AL4UZ;AK1UI;EACI,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,2CAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,4DAAA;EACA,WAAA;AL4UR;AK1UQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;AL4UZ;AK1UQ;EACI,kCAAA;EACA,cAAA;EACA,wCAAA;EACA,2BAAA;AL4UZ;AK1UY;EACI,wCAAA;AL4UhB;AK1UQ;EACI,kCAAA;EACA,cAAA;EACA,wCAAA;EACA,2BAAA;AL4UZ;AK1UY;EACI,wCAAA;AL4UhB;AK1UI;EACI,gBAAA;EACA,cAAA;EACA,uCAAA;AL4UR;AK1UI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AL4UR;AK1UI;EACI,aAAA;EACA,QAAA;AL4UR;AK1UI;EACI,8DAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AL4UR;;AKzUA;EACI,uCAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AL4UJ;;AM5cA;EACI,qBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,8DAAA;EACA,mBAAA;EACA,kCAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AN+cJ;AM7cI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,0BAAA;AN+cR;AM7cI;EACI,yCAAA;EACA,oCAAA;EACA,2CAAA;AN+cR;AM7cQ;EACI,UAAA;AN+cZ;AM7cI;EACI,sCAAA;EACA,cAAA;EACA,iCAAA;AN+cR;AM7cQ;EACI,yCAAA;EACA,oCAAA;EACA,cAAA;AN+cZ;;AOtfA;EACI,kBAAA;EACA,kBAAA;APyfJ;AOvfI;EACI,aAAA;APyfR;AOvfI;EACI,eAAA;EACA,yBAAA;APyfR;AOvfQ;EACI,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;APyfZ;AOvfQ;EACI,mBAAA;APyfZ;AOvfY;EACI,cAAA;APyfhB;AOvfI;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mCAAA;EAEA,SAAA;EACA,2BAAA;APwfR;AOtfI;EACI,eAAA;EACA,YAAA;EACA,yBAAA;APwfR;AOtfQ;EACI,mBAAA;APwfZ;AOtfQ;EACI,mBAAA;APwfZ;AOtfQ;EACI,gBAAA;APwfZ;;AQtiBA;EACI,WAAA;EACA,eAAA;ARyiBJ;AQviBI;EACI,WAAA;EACA,eAAA;ARyiBR;AQviBI;EACI,+BAAA;ARyiBR;;ASljBA;EACI,iBAAA;EACA,cAAA;EAEA,WAAA;ATojBJ;ASljBI;EAEQ,eAAA;EACA,gBAAA;ATmjBZ;ASjjBQ;EACI,YAAA;EACA,qBAAA;ATmjBZ;ASjjBI;EACI,kBAAA;EACA,gBAAA;ATmjBR;;AUpkBA;EAEQ,eAAA;EACA,gBAAA;EAEJ,kBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AVqkBJ;AUnkBI;EACI,YAAA;EACA,qBAAA;AVqkBR;AUnkBI;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,QAAA;AVqkBR;;AW5lBA;EAEI,iBCiBY;EDhBZ,cAAA;EACA,kBAAA;AX8lBJ;AW5lBI;EANJ;IAOQ,aAAA;EX+lBN;AACF;;AW9lBA;EACI,iBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AXimBJ;;AahnBA;EACI,aAAA;EACA,QAAA;AbmnBJ;AajnBI;EACI,eAAA;EACA,WAAA;AbmnBR;AajnBI;EACI,gBAAA;AbmnBR;;Ac5nBA;EACI,wCAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Ad+nBJ;Ac7nBI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;EACA,UAAA;EACA,6BAAA;Ad+nBR;Ac7nBI;EACI,oCAAA;EACA,mFAAA;Ad+nBR;Ac7nBQ;EACI,UAAA;Ad+nBZ;Ac7nBI;EACI,aAAA;EACA,eAAA;EACA,QAAA;Ad+nBR;Ac7nBI;EACI,+CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;Ad+nBR;Ac7nBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8EAAA;Ad+nBZ;Ac7nBI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;Ad+nBR;Ac7nBI;EACI,8DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;Ad+nBR;Ac7nBI;EACI,cAAA;EACA,cAAA;EACA,gBAAA;Ad+nBR;Ac7nBI;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,+CAAA;EACA,eAAA;EACA,uCAAA;EACA,qBAAA;Ad+nBR;;Ac7nBA;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EAKA,SAAA;EACA,kBAAA;EACA,gBAAA;Ad4nBJ;AcjoBI;EALJ;IAMQ,2DAAA;EdooBN;AACF;;AeptBA;EACI,yCAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AfutBJ;AertBI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mFAAA;EACA,YAAA;EACA,6BAAA;AfutBR;AertBI;EACI,oCAAA;EACA,4CAAA;AfutBR;AertBQ;EACI,UAAA;AfutBZ;AertBI;EACI,gBAAA;EACA,aAAA;EACA,+CAAA;EACA,8DAAA;EACA,cAAA;EACA,mBAAA;AfutBR;AertBI;EACI,aAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;AfutBR;;AgBlwBA;EACI,2BAAA;EACA,2YAAA;AhBqwBJ;AgBnwBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AhBqwBJ;;AgBlwBA;EACI,8BAAA;EACA,SAAA;EACA,UAAA;AhBqwBJ;;AgBlwBA;EACI,kBAAA;EACA,UAAA;AhBqwBJ;AgBlwBI;EACI,yEAAA;EACA,cAAA;AhBowBR;AgBlwBI;EACI,yEAAA;EACA,cAAA;AhBowBR;;AgBjwBA;EACI,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,0BAAA;EACA,+CAAA;AhBowBJ;;AgBlwBA;EACI,4CAAA;EACA,mBAAA;AhBqwBJ;;AgBlwBA;EACI,wCAAA;EACA,yBAAA;AhBqwBJ;AgBnwBI;EACI,yEAAA;EACA,6BAAA;AhBqwBR;;AgBlwBA;EACI,6BAAA;EACA,yBAAA;EACA,8BAAA;EACA,0BAAA;AhBqwBJ;AgBnwBI;EACI,oCAAA;EACA,oFAAA;EACA,iCAAA;AhBqwBR;;AgBlwBA;EACI,+BAAA;EACA,wCAAA;EACA,uCAAA;AhBqwBJ;AgBnwBI;EACI,oCAAA;EACA,kFAAA;AhBqwBR;;AgBlwBA;EACI,kBAAA;AhBqwBJ;AgBnwBI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sFAAA;EACA,OAAA;EACA,MAAA;AhBqwBR;;AgBlwBA;EACI,kBAAA;AhBqwBJ;AgBnwBI;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;AhBqwBR;;AgBlwBA;EACI,8DAAA;EACA,mBAAA;AhBqwBJ;AgBnwBI;EACI,iBAAA;EACA,YAAA;AhBqwBR;;AgBlwBA;EACI,kBAAA;AhBqwBJ;AgBnwBI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+GAAA;EACA,oBAAA;AhBqwBR;;AiB14BA;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AjB64BJ;AiB34BI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AjB64BR;AiB34BI;EACI,SAAA;EACA,gBAAA;AjB64BR;AiB34BI;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjB64BR;AiB34BI;EACI,cAAA;EACA,gBAAA;EACA,uCAAA;AjB64BR;AiB34BI;EACI,SAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AjB64BR;AiB34BQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6EAAA;AjB64BZ;AiB34BQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AjB64BZ;;AkBr8BA;EACI,WAAA;AlBw8BJ;AkBt8BI;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AlBw8BR;AkBt8BI;EACI,gBAAA;AlBw8BR;AkBt8BI;EACI,gBAAA;AlBw8BR;AkBt8BI;EACI,6BAAA;EACA,aAAA;AlBw8BR;AkBt8BI;EACI,kBAAA;EACA,gBAAA;AlBw8BR;;AkBt8BA;EACI,aAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AlBy8BJ;AkBv8BI;EACI,+BAAA;AlBy8BR;;AmB1+BA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AnB6+BJ;AmB1+BI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qHAAA;EACA,oBAAA;EACA,UAAA;AnB4+BR;AmB1+BI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AnB4+BR;AmB1+BI;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AnB4+BR;AmB1+BI;EACI,kBAAA;EACA,UAAA;EACA,+CAAA;EACA,6CAAA;AnB4+BR;AmB1+BI;EACI,SAAA;EACA,kBAAA;EACA,UAAA;AnB4+BR;AmB1+BI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;AnB4+BR;AmB1+BI;EACI,gBAAA;EACA,eAAA;EACA,6DAAA;EACA,kBAAA;EACA,8DAAA;EAGI,eAAA;EACA,gBAAA;AnB0+BZ;AmBx+BQ;EACI,cAAA;EACA,4BAAA;EACA,4CAAA;AnB0+BZ;AmBx+BQ;EACI,oEAAA;AnB0+BZ;AmBx+BY;EACI,cAAA;AnB0+BhB;AmBx+BI;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AnB0+BR;AmBx+BI;EACI,iBAAA;EACA,wCAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,8BAAA;EACA,0BAAA;AnB0+BR;AmBx+BQ;EACI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;EACA,wCAAA;AnB0+BZ;AmBx+BQ;EACI,cAAA;EACA,0BAAA;EACA,0BAAA;AnB0+BZ;AmBx+BY;EACI,cAAA;EACA,4CAAA;AnB0+BhB;AmBv+BI;EACI,uCAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AnBy+BR;;AmBt+BA;EACI,WAAA;EACA,oFAAA;EACA,cAAA;EACA,kBAAA;AnBy+BJ;AmBv+BI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,cAAA;AnBy+BR;AmBv+BI;EACI,SAAA;AnBy+BR;AmBv+BI;EACI,UAAA;AnBy+BR;;AmBv+BA;EACI;IACI,YAAA;IACA,iBAAA;IACA,sBAAA;EnB0+BN;EmBz+BE;IACI,YAAA;IACA,iBAAA;IACA,sBAAA;EnB2+BN;EmB1+BE;IACI,UAAA;IACA,eAAA;IACA,mBAAA;EnB4+BN;AACF;AmB1+BA;EACI;IACI,yCAAA;IACA,UAAA;EnB4+BN;EmB3+BE;IACI,UAAA;EnB6+BN;EmB5+BE;IACI,UAAA;EnB8+BN;EmB7+BE;IACI,2CAAA;IACA,UAAA;EnB++BN;AACF;AmB9+BA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,4FAAA;EACA,8CAAA;EACA,wCAAA;EACA,oBAAA;EACA,UAAA;AnBg/BJ;AmB9+BI;EACI,SAAA;EACA,mBAAA;EACA,sBAAA;AnBg/BR;AmB9+BI;EACI,SAAA;EACA,oBAAA;EACA,uBAAA;AnBg/BR;AmB9+BI;EACI,SAAA;EACA,oBAAA;EACA,sBAAA;AnBg/BR;AmB9+BI;EACI,SAAA;EACA,oBAAA;EACA,sBAAA;AnBg/BR;;AoBprCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;ApBurCR;AoBrrCI;EACI,0BAAA;ApBurCR;AoBrrCQ;EACI,qBAAA;ApBurCZ;;AqBnsCA;EACI,6BAAA;EACA,kBAAA;EAEA,SAAA;ArBqsCJ;AqBnsCI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uEAAA;EACA,yBAAA;EACA,4BAAA;ArBqsCR;AqBlsCI;EACI,UAAA;EACA,UAAA;ArBosCR;AqBlsCI;EACI,aAAA;EACA,WAAA;ArBosCR;AqBlsCI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;ArBosCR;AqBlsCI;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;ArBosCR;AqBlsCQ;EACI,aAAA;ArBosCZ;;AsB5uCA;EACI,WAAA;EACA,kBAAA;AtB+uCJ;AsB7uCI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AtB+uCR;AsB7uCI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AtB+uCR;AsB7uCI;EACI,mBAAA;AtB+uCR;AsB7uCI;EACI,gBAAA;EACA,UAAA;AtB+uCR;AsB7uCQ;EAJJ;IAKQ,UAAA;EtBgvCV;AACF;AsB/uCQ;EAPJ;IAQQ,UAAA;EtBkvCV;AACF;AsBjvCI;EACI,SAAA;AtBmvCR;;AsBhvCA;EACI,8DAAA;EACA,kBAAA;EACA,qBAAA;AtBmvCJ;AsBjvCI;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AtBmvCR;;AsBjvCA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AtBovCJ;AsBlvCI;EACI,aAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AtBovCR;AsBlvCI;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AtBovCR;AsBlvCI;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AtBovCR;;Ac3zCA;EACI,wCAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Ad8zCJ;Ac5zCI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;EACA,UAAA;EACA,6BAAA;Ad8zCR;Ac5zCI;EACI,oCAAA;EACA,mFAAA;Ad8zCR;Ac5zCQ;EACI,UAAA;Ad8zCZ;Ac5zCI;EACI,aAAA;EACA,eAAA;EACA,QAAA;Ad8zCR;Ac5zCI;EACI,+CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;Ad8zCR;Ac5zCQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8EAAA;Ad8zCZ;Ac5zCI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;Ad8zCR;Ac5zCI;EACI,8DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;Ad8zCR;Ac5zCI;EACI,cAAA;EACA,cAAA;EACA,gBAAA;Ad8zCR;Ac5zCI;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,+CAAA;EACA,eAAA;EACA,uCAAA;EACA,qBAAA;Ad8zCR;;Ac5zCA;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EAKA,SAAA;EACA,kBAAA;EACA,gBAAA;Ad2zCJ;Ach0CI;EALJ;IAMQ,2DAAA;Edm0CN;AACF;;Aen5CA;EACI,yCAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Afs5CJ;Aep5CI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mFAAA;EACA,YAAA;EACA,6BAAA;Afs5CR;Aep5CI;EACI,oCAAA;EACA,4CAAA;Afs5CR;Aep5CQ;EACI,UAAA;Afs5CZ;Aep5CI;EACI,gBAAA;EACA,aAAA;EACA,+CAAA;EACA,8DAAA;EACA,cAAA;EACA,mBAAA;Afs5CR;Aep5CI;EACI,aAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;Afs5CR;;Aev8CA;EACI,yCAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Af08CJ;Aex8CI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mFAAA;EACA,YAAA;EACA,6BAAA;Af08CR;Aex8CI;EACI,oCAAA;EACA,4CAAA;Af08CR;Aex8CQ;EACI,UAAA;Af08CZ;Aex8CI;EACI,gBAAA;EACA,aAAA;EACA,+CAAA;EACA,8DAAA;EACA,cAAA;EACA,mBAAA;Af08CR;Aex8CI;EACI,aAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;Af08CR;;AuB3/CA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AvB8/CJ;AuB5/CI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;AvB8/CR;AuB3/CI;EACI,mBAAA;AvB6/CR;AuB3/CI;EACI,SAAA;EACA,gBAAA;AvB6/CR;AuB3/CI;EACI,uCAAA;AvB6/CR;;AwBjhDI;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AxBohDR;;AyB1hDA;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;AzB6hDJ;;AyB1hDI;EACI,aAAA;EACA,kBAAA;EACA,eAAA;AzB6hDR;AyB3hDI;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AzB6hDR;;Ac7iDA;EACI,wCAAA;EACA,+BAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AdgjDJ;Ac9iDI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;EACA,UAAA;EACA,6BAAA;AdgjDR;Ac9iDI;EACI,oCAAA;EACA,mFAAA;AdgjDR;Ac9iDQ;EACI,UAAA;AdgjDZ;Ac9iDI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AdgjDR;Ac9iDI;EACI,+CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AdgjDR;Ac9iDQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8EAAA;AdgjDZ;Ac9iDI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;AdgjDR;Ac9iDI;EACI,8DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AdgjDR;Ac9iDI;EACI,cAAA;EACA,cAAA;EACA,gBAAA;AdgjDR;Ac9iDI;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,+CAAA;EACA,eAAA;EACA,uCAAA;EACA,qBAAA;AdgjDR;;Ac9iDA;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EAKA,SAAA;EACA,kBAAA;EACA,gBAAA;Ad6iDJ;AcljDI;EALJ;IAMQ,2DAAA;EdqjDN;AACF;;AmBroDA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AnBwoDJ;AmBroDI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qHAAA;EACA,oBAAA;EACA,UAAA;AnBuoDR;AmBroDI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AnBuoDR;AmBroDI;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AnBuoDR;AmBroDI;EACI,kBAAA;EACA,UAAA;EACA,+CAAA;EACA,6CAAA;AnBuoDR;AmBroDI;EACI,SAAA;EACA,kBAAA;EACA,UAAA;AnBuoDR;AmBroDI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;AnBuoDR;AmBroDI;EACI,gBAAA;EACA,eAAA;EACA,6DAAA;EACA,kBAAA;EACA,8DAAA;EAGI,eAAA;EACA,gBAAA;AnBqoDZ;AmBnoDQ;EACI,cAAA;EACA,4BAAA;EACA,4CAAA;AnBqoDZ;AmBnoDQ;EACI,oEAAA;AnBqoDZ;AmBnoDY;EACI,cAAA;AnBqoDhB;AmBnoDI;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AnBqoDR;AmBnoDI;EACI,iBAAA;EACA,wCAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,8BAAA;EACA,0BAAA;AnBqoDR;AmBnoDQ;EACI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;EACA,wCAAA;AnBqoDZ;AmBnoDQ;EACI,cAAA;EACA,0BAAA;EACA,0BAAA;AnBqoDZ;AmBnoDY;EACI,cAAA;EACA,4CAAA;AnBqoDhB;AmBloDI;EACI,uCAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AnBooDR;;AmBjoDA;EACI,WAAA;EACA,oFAAA;EACA,cAAA;EACA,kBAAA;AnBooDJ;AmBloDI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,cAAA;AnBooDR;AmBloDI;EACI,SAAA;AnBooDR;AmBloDI;EACI,UAAA;AnBooDR;;AmBloDA;EACI;IACI,YAAA;IACA,iBAAA;IACA,sBAAA;EnBqoDN;EmBpoDE;IACI,YAAA;IACA,iBAAA;IACA,sBAAA;EnBsoDN;EmBroDE;IACI,UAAA;IACA,eAAA;IACA,mBAAA;EnBuoDN;AACF;AmBroDA;EACI;IACI,yCAAA;IACA,UAAA;EnBuoDN;EmBtoDE;IACI,UAAA;EnBwoDN;EmBvoDE;IACI,UAAA;EnByoDN;EmBxoDE;IACI,2CAAA;IACA,UAAA;EnB0oDN;AACF;AmBzoDA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,4FAAA;EACA,8CAAA;EACA,wCAAA;EACA,oBAAA;EACA,UAAA;AnB2oDJ;AmBzoDI;EACI,SAAA;EACA,mBAAA;EACA,sBAAA;AnB2oDR;AmBzoDI;EACI,SAAA;EACA,oBAAA;EACA,uBAAA;AnB2oDR;AmBzoDI;EACI,SAAA;EACA,oBAAA;EACA,sBAAA;AnB2oDR;AmBzoDI;EACI,SAAA;EACA,oBAAA;EACA,sBAAA;AnB2oDR;;AiBh1DA;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AjBm1DJ;AiBj1DI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AjBm1DR;AiBj1DI;EACI,SAAA;EACA,gBAAA;AjBm1DR;AiBj1DI;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBm1DR;AiBj1DI;EACI,cAAA;EACA,gBAAA;EACA,uCAAA;AjBm1DR;AiBj1DI;EACI,SAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AjBm1DR;AiBj1DQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6EAAA;AjBm1DZ;AiBj1DQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AjBm1DZ;;AkB34DA;EACI,WAAA;AlB84DJ;AkB54DI;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AlB84DR;AkB54DI;EACI,gBAAA;AlB84DR;AkB54DI;EACI,gBAAA;AlB84DR;AkB54DI;EACI,6BAAA;EACA,aAAA;AlB84DR;AkB54DI;EACI,kBAAA;EACA,gBAAA;AlB84DR;;AkB54DA;EACI,aAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AlB+4DJ;AkB74DI;EACI,+BAAA;AlB+4DR;;AoB/6DI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;ApBk7DR;AoBh7DI;EACI,0BAAA;ApBk7DR;AoBh7DQ;EACI,qBAAA;ApBk7DZ;;AqB97DA;EACI,6BAAA;EACA,kBAAA;EAEA,SAAA;ArBg8DJ;AqB97DI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uEAAA;EACA,yBAAA;EACA,4BAAA;ArBg8DR;AqB77DI;EACI,UAAA;EACA,UAAA;ArB+7DR;AqB77DI;EACI,aAAA;EACA,WAAA;ArB+7DR;AqB77DI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;ArB+7DR;AqB77DI;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;ArB+7DR;AqB77DQ;EACI,aAAA;ArB+7DZ;;AsBv+DA;EACI,WAAA;EACA,kBAAA;AtB0+DJ;AsBx+DI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AtB0+DR;AsBx+DI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AtB0+DR;AsBx+DI;EACI,mBAAA;AtB0+DR;AsBx+DI;EACI,gBAAA;EACA,UAAA;AtB0+DR;AsBx+DQ;EAJJ;IAKQ,UAAA;EtB2+DV;AACF;AsB1+DQ;EAPJ;IAQQ,UAAA;EtB6+DV;AACF;AsB5+DI;EACI,SAAA;AtB8+DR;;AsB3+DA;EACI,8DAAA;EACA,kBAAA;EACA,qBAAA;AtB8+DJ;AsB5+DI;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AtB8+DR;;AsB5+DA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AtB++DJ;AsB7+DI;EACI,aAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AtB++DR;AsB7+DI;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AtB++DR;AsB7+DI;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AtB++DR;;AuBtjEA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AvByjEJ;AuBvjEI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;AvByjER;AuBtjEI;EACI,mBAAA;AvBwjER;AuBtjEI;EACI,SAAA;EACA,gBAAA;AvBwjER;AuBtjEI;EACI,uCAAA;AvBwjER;;AyB7kEA;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;AzBglEJ;;AyB7kEI;EACI,aAAA;EACA,kBAAA;EACA,eAAA;AzBglER;AyB9kEI;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AzBglER;;AwB/lEI;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AxBkmER;;AAvkEA;EAEQ,yBAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,qBAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,sBAAA;EAAA,4BAAA;EAAA,8BAAA;AAklER","sourcesContent":["@import '../assets/styles/default/font'\r\n@import '../assets/styles/default/variables'\r\n@import '../assets/styles/default/reset'\r\n@import '../assets/styles/default/default'\r\n\r\n@import '../assets/styles/components/header'\r\n@import '../assets/styles/components/footer'\r\n@import '../assets/styles/components/button'\r\n@import '../assets/styles/components/dropdown'\r\n@import '../assets/styles/components/mediaIcon'\r\n@import '../assets/styles/components/path'\r\n@import '../assets/styles/components/h2'\r\n@import '../assets/styles/components/container'\r\n@import '../assets/styles/components/logo'\r\n@import '../assets/styles/components/project'\r\n@import '../assets/styles/components/skillBlock'\r\n@import '../assets/styles/components/matrix'\r\n\r\n@import '../assets/styles/pages/home'\r\n@import '../assets/styles/pages/about'\r\n@import '../assets/styles/pages/projects'\r\n\r\n@import '../assets/styles/blocks/home/hero'\r\n@import '../assets/styles/blocks/home/about'\r\n@import '../assets/styles/blocks/home/contacts'\r\n@import '../assets/styles/blocks/home/projects'\r\n@import '../assets/styles/blocks/home/quote'\r\n@import '../assets/styles/blocks/home/skills'\r\n\r\n@import '../assets/styles/blocks/about/about'\r\n@import '../assets/styles/blocks/about/facts'\r\n@import '../assets/styles/blocks/about/skills'\r\n\r\n:root\r\n    @each $key, $value in $colors\r\n        --#{\"\" + $key}: hsl(#{$value})\r\n","\r\n$fonts: (\"Light\": 300,\"Regular\": 400,\"Medium\": 500,\"SemiBold\": 600,\"Bold\": 700)\r\n$format: \"woff\"\r\n\r\n@each $name, $weight in $fonts\r\n    @font-face\r\n        font:\r\n            family: \"Fira Code\"\r\n            weight: $weight\r\n            style: normal\r\n        src: url(\"../../fonts/fira-code/FiraCode-#{$name}.#{$format}\") format($format)\r\n","html,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\na,\r\nimg,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\narticle,\r\naside,\r\ndetails,\r\nheader,\r\nnav,\r\nsection,\r\nsummary\r\n    margin: 0\r\n    padding: 0\r\n    border: 0\r\n    font-size: 100%\r\n    font: inherit\r\n    vertical-align: baseline\r\n\r\nbody\r\n    min-height: 100vh\r\n    text-rendering: optimizeSpeed\r\n    line-height: 1.5\r\n    overflow-x: hidden\r\n\r\na\r\n    text-decoration: none\r\n    color: inherit\r\n\r\nul\r\n    list-style: none\r\n\r\nimg,\r\npicture\r\n    max-width: 100%\r\n    display: block\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect\r\n    font: inherit\r\n\r\n\r\nbutton \r\n    appearance: none\r\n\r\n*,\r\n*::before,\r\n*::after\r\n    box-sizing: border-box\r\n","// Import Japanese fonts for samurai theme\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap')\r\n\r\nbody, html\r\n    background-color: #050508 !important\r\n    color: #e0e0e0\r\n    font-family: \"Fira Code\", \"Noto Sans JP\", monospace\r\n    display: flex\r\n    gap: 112px\r\n    flex-direction: column\r\n    margin: 0\r\n    padding: 0\r\n    min-height: 100vh\r\n    overflow-x: hidden\r\n\r\n// Add atmospheric background\r\nbody\r\n    &::before\r\n        content: ''\r\n        position: fixed\r\n        top: 0\r\n        left: 0\r\n        right: 0\r\n        bottom: 0\r\n        background: radial-gradient(ellipse at 20% 20%, rgba(180, 30, 30, 0.05) 0%, transparent 40%), radial-gradient(ellipse at 80% 80%, rgba(30, 30, 40, 0.1) 0%, transparent 40%), linear-gradient(180deg, #050508 0%, #0a0a12 50%, #050508 100%)\r\n        pointer-events: none\r\n        z-index: -1000\r\n\r\n.dots\r\n    width: 10vmin\r\n    height: auto\r\n\r\n    circle\r\n        fill: #606060\r\n\r\n// Global scrollbar styling\r\n::-webkit-scrollbar\r\n    width: 8px\r\n\r\n::-webkit-scrollbar-track\r\n    background: #050508\r\n\r\n::-webkit-scrollbar-thumb\r\n    background: rgba(180, 30, 30, 0.4)\r\n    border-radius: 4px\r\n    \r\n    &:hover\r\n        background: rgba(180, 30, 30, 0.6)\r\n\r\n// Selection styling\r\n::selection\r\n    background: rgba(180, 30, 30, 0.4)\r\n    color: #ffffff\r\n","// Import Japanese fonts\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap')\r\n\r\n$screen: 768px\r\n\r\n.media-header \r\n    position: fixed\r\n    display: flex\r\n    flex-direction: column\r\n    align-items: center\r\n    justify-content: center\r\n    left: 16px\r\n    gap: 8px\r\n    top: 0px\r\n\r\n    @media (max-width: $desktopScreen) \r\n        display: none\r\n    \r\n\r\n    &__links \r\n        display: grid\r\n        grid-auto-columns: 1fr\r\n\r\n    &__line \r\n        width: 1px\r\n        height: 33vh\r\n        background-color: rgba(180, 30, 30, 0.3)\r\n        display: block\r\n\r\n.hamburger\r\n    width: 32px\r\n    margin: 0\r\n    aspect-ratio: 1\r\n    display: none\r\n    appearance: none\r\n    position: absolute\r\n    cursor: pointer\r\n    right: 8px\r\n    top: 32px\r\n    z-index: 9999\r\n\r\n    &::before, &::after\r\n        content: \"\"\r\n        width: 100%\r\n        height: 2px\r\n        position: absolute\r\n        top: 30%\r\n        background-color: rgba(180, 30, 30, 0.7)\r\n        transition: all 0.2s ease\r\n\r\n    &::after\r\n        width: 75%\r\n        top: 70%\r\n        right: 0\r\n\r\n    @media (max-width: $desktopScreen)\r\n        display: block\r\n\r\n        &:checked \r\n            &::after\r\n                transform: translateY(-50%) rotateZ(45deg)\r\n                width: 100%\r\n                top: 50%\r\n\r\n            &::before\r\n                transform: translateY(-50%) rotateZ(-45deg)\r\n                top: 50%\r\n\r\n\r\n            & ~ .media-header\r\n                display: flex\r\n                top: calc(100% - 16px)\r\n                left: 50%\r\n                transform: translate(-50%, -100%)\r\n                z-index: 9999\r\n\r\n                .media\r\n                    width: 48px\r\n\r\n                .media-header__links\r\n                    display: flex\r\n                    gap: 16px\r\n\r\n                .media-header__line\r\n                    display: none\r\n                    \r\n\r\n            & ~ .container\r\n                width: 100vw\r\n                height: 100vh\r\n\r\n                .dropdown\r\n                    display: flex\r\n                    position: absolute\r\n                    bottom: -16px\r\n                    font-size: 24px\r\n                    transform: translateY(100%)\r\n                    right: 0\r\n\r\n                .header\r\n                    &__inner\r\n                        align-items: start\r\n\r\n                    &__links\r\n                        display: flex\r\n                        position: absolute\r\n                        flex-direction: column\r\n                        bottom: -32px\r\n                        transform: translateY(100%)\r\n                        font-size: 24px\r\n\r\n\r\n.header \r\n    padding:\r\n        top: 32px\r\n        bottom: 8px\r\n    background-color: rgba(5, 5, 8, 0.85)\r\n    position: fixed\r\n    top: 0\r\n    width: 100%\r\n    z-index: 999\r\n    backdrop-filter: blur(10px)\r\n    border-bottom: 1px solid rgba(180, 30, 30, 0.2)\r\n    \r\n    &__inner\r\n        display: flex\r\n        width: 100%\r\n        justify-content: space-between\r\n        align-items: center\r\n        gap: 16px\r\n        position: relative\r\n\r\n\r\n    &__links \r\n        margin-left: auto\r\n        display: flex\r\n        align-items: flex-start\r\n        gap: 32px\r\n        \r\n    \r\n    &__link\r\n        color: #909090\r\n        font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n        letter-spacing: 1px\r\n        position: relative\r\n        transition: all 0.3s ease\r\n\r\n        &_active\r\n            font-weight: 600\r\n            color: #e0e0e0\r\n            text-shadow: 0 0 10px rgba(180, 30, 30, 0.5)\r\n\r\n        &::before\r\n            content: \"‡\"\r\n            color: rgba(180, 30, 30, 0.8)\r\n            font-weight: normal\r\n            margin-right: 4px\r\n            opacity: 0\r\n            transition: opacity 0.3s ease\r\n        \r\n        &:hover \r\n            color: #e04545\r\n            text-shadow: 0 0 15px rgba(180, 30, 30, 0.5)\r\n            \r\n            &::before\r\n                opacity: 1\r\n\r\n    @media (max-width: $desktopScreen) \r\n        padding-top: 16px\r\n\r\n        &__links, .dropdown\r\n            display: none\r\n\r\n","// Import Japanese fonts\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap')\r\n\r\n.footer \r\n    max-width: inherit\r\n    width: 100%\r\n    border-top: 1px solid rgba(180, 30, 30, 0.3)\r\n    padding-top: 32px\r\n    margin-bottom: 16px\r\n    background: linear-gradient(180deg, transparent 0%, rgba(5, 5, 8, 0.5) 100%)\r\n\r\n    &__copyright\r\n        color: #707070\r\n        text-align: center\r\n        font-family: 'Noto Sans JP', sans-serif\r\n        font-size: 12px\r\n        letter-spacing: 1px\r\n\r\n    &__header\r\n        display: flex\r\n        gap: 32px\r\n        align-items: center\r\n\r\n    &__contact-group\r\n        display: flex\r\n        align-items: center\r\n        gap: 12px\r\n\r\n    &__contact-divider\r\n        color: rgba(180, 30, 30, 0.4)\r\n        opacity: 0.5\r\n        user-select: none\r\n\r\n    &__contact-item\r\n        position: relative\r\n        display: inline-flex\r\n        align-items: center\r\n\r\n        &:hover .footer__tooltip\r\n            opacity: 1\r\n            visibility: visible\r\n            transform: translateX(-50%) translateY(0)\r\n\r\n    &__email, &__phone\r\n        color: #909090\r\n        transition: all 0.25s ease\r\n        text-decoration: none\r\n        font-family: 'Noto Sans JP', sans-serif\r\n\r\n        &:hover\r\n            color: #e04545\r\n            text-shadow: 0 0 10px rgba(180, 30, 30, 0.5)\r\n\r\n    &__tooltip\r\n        position: absolute\r\n        bottom: calc(100% + 10px)\r\n        left: 50%\r\n        transform: translateX(-50%) translateY(6px)\r\n        white-space: nowrap\r\n        padding: 6px 14px\r\n        border-radius: 4px\r\n        font-size: 12px\r\n        font-weight: 500\r\n        letter-spacing: 0.02em\r\n        pointer-events: none\r\n        opacity: 0\r\n        visibility: hidden\r\n        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\r\n        z-index: 10\r\n\r\n        &::after\r\n            content: ''\r\n            position: absolute\r\n            top: 100%\r\n            left: 50%\r\n            transform: translateX(-50%)\r\n            border: 5px solid transparent\r\n\r\n        &--email\r\n            background: rgba(180, 30, 30, 0.2)\r\n            color: #e04545\r\n            border: 1px solid rgba(180, 30, 30, 0.4)\r\n            backdrop-filter: blur(12px)\r\n\r\n            &::after\r\n                border-top-color: rgba(180, 30, 30, 0.4)\r\n\r\n        &--phone\r\n            background: rgba(180, 30, 30, 0.2)\r\n            color: #e04545\r\n            border: 1px solid rgba(180, 30, 30, 0.4)\r\n            backdrop-filter: blur(12px)\r\n\r\n            &::after\r\n                border-top-color: rgba(180, 30, 30, 0.4)\r\n\r\n    &__description\r\n        margin-top: 16px\r\n        color: #808080\r\n        font-family: 'Noto Sans JP', sans-serif\r\n\r\n    &__inner\r\n        display: flex\r\n        justify-content: space-between\r\n        flex-wrap: wrap\r\n        gap: 32px\r\n        margin-bottom: 48px\r\n\r\n    &__list\r\n        display: flex\r\n        gap: 8px\r\n    \r\n    &__title\r\n        font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n        font-weight: 500\r\n        font-size: 24px\r\n        color: #e0e0e0\r\n        letter-spacing: 2px\r\n\r\n// Japanese footer accent\r\n.footer-japanese\r\n    font-family: 'Noto Sans JP', sans-serif\r\n    font-size: 10px\r\n    color: rgba(180, 30, 30, 0.6)\r\n    letter-spacing: 4px\r\n    text-transform: uppercase\r\n    text-align: center\r\n    margin-top: 16px\r\n    opacity: 0.7\r\n",".button\r\n    display: inline-block\r\n    padding: 10px 20px\r\n    border: 1px solid rgba(180, 30, 30, 0.6)\r\n    font-weight: 500\r\n    font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n    letter-spacing: 1px\r\n    background: rgba(180, 30, 30, 0.1)\r\n    color: #e0e0e0\r\n    transition: all 0.3s ease\r\n    position: relative\r\n    overflow: hidden\r\n\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: 0\r\n        left: -100%\r\n        width: 100%\r\n        height: 100%\r\n        background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.3), transparent)\r\n        transition: left 0.5s ease\r\n\r\n    &:hover\r\n        background-color: rgba(180, 30, 30, 0.25)\r\n        border-color: rgba(180, 30, 30, 0.9)\r\n        box-shadow: 0 0 20px rgba(180, 30, 30, 0.3)\r\n        \r\n        &::before\r\n            left: 100%\r\n\r\n    &__secondary\r\n        border-color: rgba(120, 120, 130, 0.5)\r\n        color: #909090\r\n        background: rgba(20, 20, 25, 0.5)\r\n\r\n        &:hover\r\n            background-color: rgba(180, 30, 30, 0.15)\r\n            border-color: rgba(180, 30, 30, 0.5)\r\n            color: #e0e0e0\r\n",".dropdown\r\n    color: var(--gray)\r\n    position: relative\r\n\r\n    &:hover &__list\r\n        display: flex\r\n\r\n    &__label\r\n        cursor: pointer\r\n        text-transform: uppercase\r\n\r\n        &::after\r\n            content: \"V\"\r\n            display: inline-block\r\n            scale: 1 0.3\r\n            font-weight: 500\r\n            margin-left: 4px\r\n\r\n        &:hover\r\n            color: var(--white)\r\n\r\n            &::after\r\n                rotate: 180deg\r\n\r\n    &__list\r\n        display: none\r\n        flex-direction: column\r\n        border: 1px solid var(--gray)\r\n        position: absolute\r\n        background-color: var(--background)\r\n\r\n        bottom: 0\r\n        transform: translateY(100%)\r\n\r\n    &__option\r\n        cursor: pointer\r\n        padding: 8px\r\n        text-transform: uppercase\r\n\r\n        &:hover\r\n            color: var(--white)\r\n\r\n        &:first-child\r\n            padding-bottom: 4px\r\n        \r\n        &:nth-child(2)\r\n            padding-top: 4px\r\n",".media\r\n    width: 32px\r\n    aspect-ratio: 1\r\n\r\n    &__icon\r\n        width: 100%\r\n        aspect-ratio: 1\r\n\r\n    &__icon:hover\r\n        filter: brightness(0) invert(1)\r\n\r\n",".path\r\n    align-self: start\r\n    display: block\r\n    \r\n    width: 100%\r\n\r\n    &__name\r\n        font: \r\n            size: 32px\r\n            weight: 600\r\n        \r\n        &::before\r\n            content: \"/\"\r\n            color: var(--primary)\r\n\r\n    &__description\r\n        color: var(--gray)\r\n        margin-top: 16px",".h2\r\n    font:\r\n        size: 32px\r\n        weight: 500\r\n    \r\n    position: relative\r\n    float: none\r\n    clear: both\r\n    display: inline-block\r\n    \r\n    &::before\r\n        content: \"#\"\r\n        color: var(--primary)\r\n    \r\n    &::after\r\n        content: \"\"\r\n        display: block\r\n        width: 10vw\r\n        height: 1px\r\n        background-color: var(--primary)\r\n        position: absolute\r\n        transform: translate(100%, -50%)\r\n        right: -16px\r\n        top: 50%\r\n",".container\r\n\r\n    max-width: $desktopScreen\r\n    margin: 0 auto\r\n    position: relative\r\n\r\n    @media (max-width: $desktopScreen)\r\n        padding: 16px\r\n\r\n.content\r\n    margin-top: 112px\r\n    flex: 1\r\n    display: flex\r\n    flex-direction: column\r\n    align-items: center\r\n    gap: 112px","$colors: (\r\n    // Samurai red primary color - deep crimson\r\n    primary: 0 80% 45%,\r\n    primary-op: 0 80% 45% / 0.1,\r\n    // Secondary red for accents\r\n    secondary: 350 70% 50%,\r\n    secondary-op: 350 70% 50% / 0.1,\r\n    // Gray tones for dark theme\r\n    gray: 0 0% 60%,\r\n    gray-op: 0 0% 60% / 0.1,\r\n    // Deep black background\r\n    background: 240 20% 3%,\r\n    // White for text\r\n    white: 0 0% 90%,\r\n    // Accent colors\r\n    accent-red: 0 85% 50%,\r\n    accent-gold: 40 80% 50%,\r\n);\r\n\r\n$desktopScreen: 1024px;\r\n$tabletScreen: 768px;\r\n$mobileScreen: 500px;\r\n\r\n// Additional samurai theme variables\r\n$samurai-red: #b41e1e;\r\n$samurai-red-bright: #e04545;\r\n$samurai-red-dark: #8a1515;\r\n$dark-black: #050508;\r\n$dark-gray: #0a0a0f;\r\n$text-gray: #909090;\r\n$text-light: #e0e0e0;",".logo\r\n    display: flex\r\n    gap: 8px\r\n\r\n    &__img\r\n        aspect-ratio: 1\r\n        width: 16px\r\n\r\n    &__name\r\n        font-weight: 700",".project\r\n    border: 1px solid rgba(180, 30, 30, 0.3)\r\n    background: rgba(8, 8, 12, 0.6)\r\n    backdrop-filter: blur(4px)\r\n    transition: all 0.3s ease\r\n    position: relative\r\n    overflow: hidden\r\n\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: 0\r\n        left: 0\r\n        right: 0\r\n        height: 2px\r\n        background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent)\r\n        opacity: 0\r\n        transition: opacity 0.3s ease\r\n\r\n    &:hover\r\n        border-color: rgba(180, 30, 30, 0.6)\r\n        box-shadow: 0 0 30px rgba(180, 30, 30, 0.2), inset 0 0 20px rgba(180, 30, 30, 0.05)\r\n        \r\n        &::before\r\n            opacity: 1\r\n\r\n    &__links\r\n        display: flex\r\n        flex-wrap: wrap\r\n        gap: 8px\r\n\r\n    &__image\r\n        border-bottom: 1px solid rgba(180, 30, 30, 0.3)\r\n        aspect-ratio: 16/9\r\n        position: relative\r\n        overflow: hidden\r\n\r\n        &::after\r\n            content: ''\r\n            position: absolute\r\n            top: 0\r\n            left: 0\r\n            right: 0\r\n            bottom: 0\r\n            background: linear-gradient(180deg, transparent 50%, rgba(8, 8, 12, 0.8) 100%)\r\n\r\n    &__content\r\n        padding: 16px\r\n        position: relative\r\n        z-index: 1\r\n\r\n    &__name\r\n        font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n        font-size: 24px\r\n        font-weight: 500\r\n        color: #e0e0e0\r\n\r\n    &__description\r\n        color: #909090\r\n        margin: 16px 0\r\n        line-height: 1.6\r\n    \r\n    &__techs\r\n        display: flex\r\n        flex-wrap: wrap\r\n        gap: 8px 16px\r\n        color: #707070\r\n        padding: 8px\r\n        border-bottom: 1px solid rgba(180, 30, 30, 0.2)\r\n        font-size: 12px\r\n        font-family: 'Noto Sans JP', sans-serif\r\n        letter-spacing: 0.5px\r\n\r\n.project-list\r\n    width: 100%\r\n    display: grid\r\n    grid-template-columns: repeat(3, 1fr)\r\n\r\n    @media (max-width: $desktopScreen)\r\n        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr))\r\n\r\n    gap: 16px\r\n    align-items: start\r\n    margin-top: 48px\r\n",".skill-block\r\n    border: 1px solid rgba(180, 30, 30, 0.25)\r\n    display: inline-block\r\n    max-width: 300px\r\n    min-width: 200px\r\n    flex-grow: 1\r\n    flex-shrink: 1\r\n    flex-basis: 0\r\n    background: rgba(8, 8, 12, 0.5)\r\n    backdrop-filter: blur(4px)\r\n    transition: all 0.3s ease\r\n    position: relative\r\n    overflow: hidden\r\n\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: 0\r\n        left: 0\r\n        width: 2px\r\n        height: 100%\r\n        background: linear-gradient(180deg, rgba(180, 30, 30, 0.6), rgba(180, 30, 30, 0.1))\r\n        opacity: 0.5\r\n        transition: opacity 0.3s ease\r\n\r\n    &:hover\r\n        border-color: rgba(180, 30, 30, 0.5)\r\n        box-shadow: 0 0 20px rgba(180, 30, 30, 0.15)\r\n        \r\n        &::before\r\n            opacity: 1\r\n\r\n    &__name\r\n        font-weight: 600\r\n        padding: 12px\r\n        border-bottom: 1px solid rgba(180, 30, 30, 0.2)\r\n        font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n        color: #e0e0e0\r\n        letter-spacing: 1px\r\n\r\n    &__list\r\n        padding: 12px\r\n        display: flex\r\n        flex-wrap: wrap\r\n        gap: 8px\r\n        justify-content: start\r\n        align-items: start\r\n        color: #909090\r\n        font-family: 'Noto Sans JP', sans-serif\r\n        font-size: 13px\r\n","// Matrix font import - Japanese font for samurai theme\r\n@import url(\"https://fonts.googleapis.com/css?family=Noto+Sans+JP:wght@300;400;500;700&display=swap\")\r\n\r\n// Import katana-style font for headers\r\n@import url(\"https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap\")\r\n\r\n@font-face\r\n    font-family: 'samurai-code'\r\n    src: url('http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.eot?#iefix') format('embedded-opentype'), url('http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.woff') format('woff'), url('http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.ttf') format('truetype'), url('http://neilcarpenter.com/demos/canvas/matrix/font/matrix-code.ttf#svgFontName') format('svg')\r\n\r\n#matrix-rain\r\n    position: fixed\r\n    top: 0\r\n    left: 0\r\n    width: 100vw\r\n    height: 100vh\r\n    z-index: -1\r\n    pointer-events: none\r\n    background: #050508\r\n    display: block\r\n    margin: 0\r\n    padding: 0\r\n\r\n// Reset for matrix background - deep black samurai theme\r\nbody, html\r\n    background: #050508 !important\r\n    margin: 0\r\n    padding: 0\r\n\r\n// Add subtle glow effect to content over matrix - red accent for samurai theme\r\n.content\r\n    position: relative\r\n    z-index: 1\r\n    \r\n    // Enhanced text shadow for better readability over matrix\r\n    h1, h2, h3, h4, h5, h6\r\n        text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 30px rgba(180, 30, 30, 0.3)\r\n        color: #e8e8e8\r\n    \r\n    p\r\n        text-shadow: 0 0 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(180, 30, 30, 0.2)\r\n        color: #a0a0a0\r\n\r\n// Header and footer should also be above matrix\r\n.header, .footer\r\n    position: relative\r\n    z-index: 2\r\n    background: rgba(5, 5, 8, 0.6)\r\n    backdrop-filter: blur(8px)\r\n    border-bottom: 1px solid rgba(180, 30, 30, 0.2)\r\n    \r\n.footer\r\n    border-top: 1px solid rgba(180, 30, 30, 0.2)\r\n    border-bottom: none\r\n\r\n// Enhance the glow effect on interactive elements - red accent\r\n.button, .header__link, .contact\r\n    text-shadow: 0 0 10px rgba(0, 0, 0, 0.9)\r\n    transition: all 0.3s ease\r\n    \r\n    &:hover\r\n        text-shadow: 0 0 20px rgba(180, 30, 30, 0.6), 0 0 10px rgba(0, 0, 0, 0.9)\r\n        color: rgba(220, 60, 60, 0.9)\r\n\r\n// Matrix-inspired border effects - samurai red\r\n.project, .contact\r\n    border: 1px solid transparent\r\n    transition: all 0.3s ease\r\n    background: rgba(5, 5, 8, 0.4)\r\n    backdrop-filter: blur(4px)\r\n    \r\n    &:hover\r\n        border-color: rgba(180, 30, 30, 0.5)\r\n        box-shadow: 0 0 25px rgba(180, 30, 30, 0.25), inset 0 0 30px rgba(180, 30, 30, 0.05)\r\n        background: rgba(10, 10, 15, 0.6)\r\n\r\n// Enhanced matrix theme for skills and other elements\r\n.skill, .skillBlock\r\n    background: rgba(8, 8, 12, 0.5)\r\n    border: 1px solid rgba(180, 30, 30, 0.2)\r\n    text-shadow: 0 0 8px rgba(0, 0, 0, 0.8)\r\n    \r\n    &:hover\r\n        border-color: rgba(180, 30, 30, 0.6)\r\n        box-shadow: 0 0 20px rgba(180, 30, 30, 0.3), inset 0 0 15px rgba(180, 30, 30, 0.1)\r\n\r\n// Katana blade angular accents\r\n.katana-accent\r\n    position: relative\r\n    \r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        width: 2px\r\n        height: 100%\r\n        background: linear-gradient(to bottom, rgba(180, 30, 30, 0.8), rgba(180, 30, 30, 0.1))\r\n        left: 0\r\n        top: 0\r\n\r\n// Cherry blossom decoration\r\n.sakura-decoration\r\n    position: relative\r\n    \r\n    &::after\r\n        content: '❀'\r\n        position: absolute\r\n        right: -20px\r\n        top: 50%\r\n        transform: translateY(-50%)\r\n        color: rgba(180, 40, 60, 0.6)\r\n        font-size: 12px\r\n\r\n// Japanese text styling\r\n.japanese-text\r\n    font-family: 'Noto Sans JP', 'Zen Kaku Gothic New', sans-serif\r\n    letter-spacing: 2px\r\n    \r\n    &--small\r\n        font-size: 0.75em\r\n        opacity: 0.7\r\n\r\n// Dramatic lighting effect\r\n.dramatic-light\r\n    position: relative\r\n    \r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: 0\r\n        left: 0\r\n        right: 0\r\n        bottom: 0\r\n        background: radial-gradient(ellipse at center, transparent 0%, rgba(5, 5, 8, 0.4) 70%, rgba(5, 5, 8, 0.9) 100%)\r\n        pointer-events: none\r\n",".about\r\n    display: flex\r\n    gap: 32px\r\n    flex-wrap: wrap\r\n    justify-content: space-between\r\n    align-items: center\r\n    position: relative\r\n\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: -30px\r\n        left: 0\r\n        right: 0\r\n        height: 1px\r\n        background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.2), transparent)\r\n\r\n    &__content\r\n        flex: 1 1 0\r\n        min-width: 300px\r\n\r\n    &__text\r\n        margin-bottom: 32px\r\n        margin-top: 48px\r\n        display: flex\r\n        flex-direction: column\r\n        gap: 16px\r\n\r\n    &__description\r\n        color: #909090\r\n        line-height: 1.8\r\n        font-family: 'Noto Sans JP', sans-serif\r\n\r\n    &__image\r\n        flex: 1 1 0\r\n        max-width: 340px\r\n        border-bottom: 2px solid rgba(180, 30, 30, 0.5)\r\n        position: relative\r\n        overflow: hidden\r\n\r\n        &::before\r\n            content: ''\r\n            position: absolute\r\n            top: 0\r\n            left: 0\r\n            right: 0\r\n            bottom: 0\r\n            background: linear-gradient(180deg, transparent 60%, rgba(5, 5, 8, 0.8) 100%)\r\n\r\n        &::after\r\n            content: ''\r\n            position: absolute\r\n            bottom: 0\r\n            left: 0\r\n            right: 0\r\n            height: 2px\r\n            background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.8), transparent)\r\n",".contacts\r\n    width: 100%\r\n\r\n    &__content\r\n        display: flex\r\n        justify-content: space-between\r\n        align-items: start\r\n        flex-wrap: wrap\r\n        gap: 32px\r\n        margin-top: 48px\r\n\r\n    &__title\r\n        font-weight: 600\r\n\r\n    &__list\r\n        margin-top: 16px\r\n\r\n    &__media\r\n        border: 1px solid var(--gray)\r\n        padding: 16px\r\n\r\n    &__description\r\n        color: var(--gray)\r\n        max-width: 600px\r\n\r\n.contact\r\n    display: flex\r\n    gap: 8px\r\n    color: var(--gray)\r\n    align-items: center\r\n    margin-top: 8px\r\n\r\n    &:hover\r\n        filter: brightness(0) invert(1)\r\n        ",".hero \r\n    display: flex\r\n    justify-content: space-between\r\n    align-items: center\r\n    gap: 32px\r\n    flex-wrap: wrap\r\n    position: relative\r\n    \r\n    // Dramatic background overlay\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: 0\r\n        left: 0\r\n        right: 0\r\n        bottom: 0\r\n        background: radial-gradient(ellipse at 30% 50%, rgba(180, 30, 30, 0.08) 0%, transparent 50%, rgba(5, 5, 8, 0.4) 100%)\r\n        pointer-events: none\r\n        z-index: 0\r\n\r\n    .dots\r\n        position: absolute\r\n        top: 40%\r\n        width: 12vmin\r\n        left: 70%\r\n        z-index: 4\r\n\r\n    &__logo\r\n        position: absolute\r\n        width: 30vmin\r\n        top: 10%\r\n        z-index: 1\r\n        aspect-ratio: 1\r\n    \r\n    &__image\r\n        position: relative\r\n        z-index: 2\r\n        border-bottom: 2px solid rgba(180, 30, 30, 0.6)\r\n        box-shadow: 0 4px 20px rgba(180, 30, 30, 0.3)\r\n\r\n    &__content, &__illustrations\r\n        flex: 1 1 0\r\n        position: relative\r\n        z-index: 2\r\n\r\n    &__illustrations\r\n        position: relative\r\n        display: flex\r\n        flex-direction: column\r\n\r\n    &__title \r\n        min-width: 300px\r\n        cursor: pointer\r\n        transition: all 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275)\r\n        position: relative\r\n        font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n\r\n        font:\r\n            size: 32px\r\n            weight: 700\r\n        \r\n        span \r\n            color: #b41e1e\r\n            transition: color 0.35s ease\r\n            text-shadow: 0 0 20px rgba(180, 30, 30, 0.5)\r\n\r\n        &--hovered\r\n            animation: heroTextSwap 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)\r\n\r\n            span\r\n                color: #e04545\r\n    \r\n    &__description\r\n        color: #909090\r\n        margin-top: 32px\r\n        margin-bottom: 32px\r\n        line-height: 1.8\r\n        font-family: 'Noto Sans JP', sans-serif\r\n    \r\n    &__status\r\n        padding: 8px 16px\r\n        border: 1px solid rgba(180, 30, 30, 0.4)\r\n        color: #b0b0b0\r\n        margin: 0 auto\r\n        display: inline-flex\r\n        justify-content: center\r\n        align-items: center\r\n        position: relative\r\n        top: -1px\r\n        z-index: 5\r\n        gap: 8px\r\n        font-weight: 500\r\n        background: rgba(5, 5, 8, 0.6)\r\n        backdrop-filter: blur(4px)\r\n\r\n        &::before\r\n            content: \"\"\r\n            display: inline-block\r\n            aspect-ratio: 1\r\n            width: 16px\r\n            background-color: rgba(180, 30, 30, 0.2)\r\n            border: 1px solid rgba(180, 30, 30, 0.5)\r\n\r\n        a\r\n            color: #e0e0e0\r\n            text-decoration: underline\r\n            text-underline-offset: 3px\r\n\r\n            &:hover\r\n                color: #e04545\r\n                text-shadow: 0 0 10px rgba(224, 69, 69, 0.5)\r\n        \r\n    // Japanese subtitle accent\r\n    &__japanese\r\n        font-family: 'Noto Sans JP', sans-serif\r\n        font-size: 14px\r\n        color: rgba(180, 30, 30, 0.7)\r\n        letter-spacing: 3px\r\n        margin-top: 8px\r\n        text-transform: uppercase\r\n\r\n// Katana blade decorative element\r\n.katana-divider\r\n    height: 1px\r\n    background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.6), transparent)\r\n    margin: 24px 0\r\n    position: relative\r\n    \r\n    &::before, &::after\r\n        content: '◆'\r\n        position: absolute\r\n        top: 50%\r\n        transform: translateY(-50%)\r\n        color: rgba(180, 30, 30, 0.8)\r\n        font-size: 8px\r\n    \r\n    &::before\r\n        left: 20%\r\n    \r\n    &::after\r\n        right: 20%\r\n\r\n@keyframes heroTextSwap\r\n    0%\r\n        opacity: 0.3\r\n        filter: blur(4px)\r\n        transform: scale(0.97)\r\n    50%\r\n        opacity: 0.8\r\n        filter: blur(1px)\r\n        transform: scale(1.01)\r\n    100%\r\n        opacity: 1\r\n        filter: blur(0)\r\n        transform: scale(1)\r\n\r\n// Falling sakura petal animation in hero\r\n@keyframes sakuraFall\r\n    0%\r\n        transform: translateY(-10px) rotate(0deg)\r\n        opacity: 0\r\n    10%\r\n        opacity: 1\r\n    90%\r\n        opacity: 1\r\n    100%\r\n        transform: translateY(100vh) rotate(360deg)\r\n        opacity: 0\r\n\r\n.sakura-petal-hero\r\n    position: absolute\r\n    width: 8px\r\n    height: 8px\r\n    background: radial-gradient(circle, rgba(180, 40, 60, 0.8) 0%, rgba(200, 80, 100, 0.4) 100%)\r\n    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%\r\n    animation: sakuraFall 8s linear infinite\r\n    pointer-events: none\r\n    z-index: 1\r\n    \r\n    &:nth-child(1)\r\n        left: 10%\r\n        animation-delay: 0s\r\n        animation-duration: 8s\r\n    \r\n    &:nth-child(2)\r\n        left: 30%\r\n        animation-delay: -3s\r\n        animation-duration: 10s\r\n    \r\n    &:nth-child(3)\r\n        left: 70%\r\n        animation-delay: -5s\r\n        animation-duration: 7s\r\n    \r\n    &:nth-child(4)\r\n        left: 85%\r\n        animation-delay: -2s\r\n        animation-duration: 9s\r\n",".projects \r\n    &__header\r\n        display: flex\r\n        justify-content: space-between\r\n        align-items: center\r\n        flex-wrap: wrap\r\n        margin-bottom: 48px\r\n    \r\n    &__link\r\n        text-decoration: underline\r\n\r\n        &:hover\r\n            color: var(--primary)",".quote\r\n    border: 1px solid var(--gray)\r\n    position: relative\r\n    // display: inline-block\r\n    margin: 0\r\n\r\n    &::before, &::after\r\n        content: '\"'\r\n        position: absolute\r\n        color: var(--gray)\r\n        font-size: 64px\r\n        font-weight: 700\r\n        background-image: linear-gradient(var(--background), var(--background))\r\n        background-size: 100% 40%\r\n        background-repeat: no-repeat\r\n\r\n\r\n    &::before\r\n        top: -32px\r\n        left: 16px\r\n\r\n    &::after\r\n        bottom: -64px\r\n        right: 16px\r\n\r\n    &__text\r\n        padding: 32px\r\n        font-size: 24px\r\n        font-weight: 500\r\n        background-color: var(--background)\r\n\r\n    &__author\r\n        position: absolute\r\n        color: var(--gray)\r\n        border: 1px solid var(--gray)\r\n        padding: 8px\r\n        right: -1px\r\n        font-size: 16px\r\n\r\n        &::before\r\n            content: \"- \"\r\n",".skills\r\n    width: 100%\r\n    position: relative\r\n\r\n    &::before\r\n        content: ''\r\n        position: absolute\r\n        top: -50px\r\n        left: 0\r\n        right: 0\r\n        height: 1px\r\n        background: linear-gradient(90deg, transparent, rgba(180, 30, 30, 0.3), transparent)\r\n\r\n    &__content\r\n        display: flex\r\n        gap: 32px\r\n        flex-wrap: wrap\r\n\r\n    .skill-block\r\n        margin-bottom: 16px\r\n\r\n    &__list\r\n        column-gap: 16px\r\n        columns: 3\r\n\r\n        @media (max-width: $tabletScreen) \r\n            columns: 2\r\n\r\n        @media (max-width: $mobileScreen) \r\n            columns: 1\r\n    \r\n    &__illustrations, &__list\r\n        flex: 1 1 0\r\n\r\n// Skills section title with Japanese accent\r\n.skills-title\r\n    font-family: 'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif\r\n    position: relative\r\n    display: inline-block\r\n    \r\n    &::after\r\n        content: '技'\r\n        position: absolute\r\n        right: -30px\r\n        top: 50%\r\n        transform: translateY(-50%)\r\n        font-size: 14px\r\n        color: rgba(180, 30, 30, 0.5)\r\n        letter-spacing: 2px\r\n\r\n.illustrations\r\n    position: relative\r\n    min-width: 300px\r\n    min-height: 300px\r\n\r\n    &__logo\r\n        width: 14vmin\r\n        top: 30%\r\n        position: absolute\r\n        left: 70%\r\n\r\n    .dots:nth-of-type(2)\r\n        width: 16vmin\r\n        top: 70%\r\n        left: 10%\r\n        position: absolute\r\n\r\n    .dots:nth-of-type(1)\r\n        width: 10vmin\r\n        top: 20%\r\n        left: 40%\r\n        position: absolute\r\n",".about\r\n    display: flex\r\n    justify-content: space-between\r\n    gap: 48px\r\n    align-items: center\r\n    flex-wrap: wrap\r\n\r\n    &__text\r\n        flex: 3 1 0\r\n        color: var(--gray)\r\n        min-width: 300px\r\n\r\n\r\n    &__description\r\n        margin-bottom: 16px\r\n\r\n    &__illustrations\r\n        flex: 1 1 0\r\n        min-width: 300px\r\n\r\n    &__image\r\n        border-bottom: 1px solid var(--primary)\r\n\r\n",".skills \r\n    &__content\r\n        margin-top: 48px\r\n        display: flex\r\n        gap: 16px\r\n        flex-wrap: wrap\r\n        align-items: start",".fact \r\n    padding: 8px\r\n    color: var(--gray)\r\n    border: 1px solid var(--gray)\r\n\r\n.facts\r\n    &__content\r\n        display: flex\r\n        align-items: start\r\n        flex-wrap: wrap\r\n\r\n    &__list\r\n        margin-top: 48px\r\n        display: flex\r\n        gap: 16px\r\n        align-items: start\r\n        flex-wrap: wrap"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
